<template>
  <div>
    <div class="col-12 lg:col-12 px-0">
      <Toolbar class="mb-2">
        <template #start>
          <div class="grid">
            <div class="col-12">
              <Dropdown
                class="w-full"
                v-model="selectedUnidadFiltro"
                :options="lstUnidades"
                optionLabel="UNIDAD_SUBRED"
                placeholder="Selecciona una unidad"
                :showClear="false"
                :filter="true"
                :loading="loadingEquipos"
                @change="cargaEquipos"
              />
            </div>
          </div>
        </template>
        <template #end>
          <Button
            v-show="activeTabIndex == 1"
            label="Nuevo"
            icon="pi pi-plus"
            class="p-button-success mr-2"
            @click="agregarEquipo"
          />
        </template>
      </Toolbar>
    </div>

    <TabView @tab-click="cambioTap">
      <TabPanel header="Equipos Segmentados" :disabled="loadingTab1">
        <DataTable
          v-if="selectedUnidadFiltro && selectedUnidadFiltro.SUBRED != ''"
          :value="lstEquipos"
          v-model:expandedRows="expandedRowsSegmentados"
          dataKey="IP"
          :rowClass="rowClass"
          @rowExpand="onRowExpand"
          v-model:filters="filtersSegmentados"
          :globalFilterFields="[
            'Unidad',
            'SUBRED',
            'Ubicacion',
            'Usuario',
            'Serie',
            'SO',
            'Nombre_equipo',
            'NNI',
            'Area',
            'Observaciones',
            'Descripcion',
            'IP',
            'Marca',
            'MAC',
            'Modelo',
            'Tipo',
            'Fecha_mod',
            'Fecha_registro',
            'DatosOCS.TIPO',
          ]"
          :loading="loadingEquipos"
          scrollable
          responsiveLayout="scroll"
          scrollDirection="both"
          scrollHeight="550px"
          @selection-change="onRowSelect"
        >
          <template #header>
            <div class="table-header">
              <h5>Equipos</h5>
              <span
                >Número de equipos
                {{ lstEquipos ? lstEquipos.length : 0 }}</span
              >
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  v-model="filtersSegmentados['global'].value"
                  placeholder="Buscar..."
                />
              </span>
            </div>
          </template>
          <template #empty> No se encontraron registros. </template>
          <template #loadingEquipos>
            Cargando datos. Espere por favor.
          </template>
          <Column :expander="true" style="width: 4rem" />
          <Column  field="Botones" style="width: 6rem">
            <template #body="slotProps">
              <div class="botones-container">
                <Button
                  v-show="shouldShowButton(slotProps.data)"
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-success mr-1"
                  @click="editarEquipo(slotProps.data)"
                  style="width: 30px; height: 30px"
                />
                <Button
                  v-show="
                    slotProps.data.Id_equipo_computo !== 0 &&
                    shouldShowButton(slotProps.data)
                  "
                  icon="pi pi-times"
                  class="p-button-rounded p-button-danger"
                  @click="borrarEquipo(slotProps.data)"
                  style="width: 30px; height: 30px"
                />
               
              <Button
                v-if="slotProps.data.Tipo === 'COMPUTADORA'"
                v-show="shouldShowButton(slotProps.data)"
                icon="pi pi-list"
                class="p-button-rounded p-button-primary ml-1"
                @click="selectIP(slotProps.data)"
                style="width: 30px; height: 30px"
              />
              </div>
            </template>
          </Column>

          <Column
            field="IP"
            style="width: 11rem"
            header="IP"
            :headerStyle="{ 'font-size': '12px' }"
            sortable
          >
            <template #body="slotProps">
              {{ escribeIP(slotProps.data) }}
              <span
                v-show="slotProps.data.DatosOCS"
                class="pi pi-globe ml-1"
                style="font-size: 1.2rem; color: blueviolet"
                v-tooltip="'Con datos OCS'"
              ></span>
              <span
                v-show="
                slotProps.data.DatosOCS &&
                (slotProps.data.DatosOCS.SMANUFACTURER?.toLowerCase() !=
                  slotProps.data.Marca?.toLowerCase() ||
                  slotProps.data.DatosOCS.SMODEL?.toLowerCase() !=
                    slotProps.data.Modelo?.toLowerCase() ||
                  slotProps.data.DatosOCS.SSN?.toLowerCase() !=
                    slotProps.data.Serie?.toLowerCase() ||
                  slotProps.data.DatosOCS.MAC?.toLowerCase() !=
                    slotProps.data.MAC?.toLowerCase() ||
                  slotProps.data.DatosOCS.USERID?.toLowerCase() !=
                    slotProps.data.Usuario?.toLowerCase() ||
                  (slotProps.data.DatosOCS.NAME &&
                    slotProps.data.DatosOCS.NAME.split(
                      '.'
                    )[0].toLowerCase() !=
                      slotProps.data.Nombre_equipo?.toLowerCase()))
                "
                class="pi pi-info-circle ml-1"
                style="font-size: 1.2rem; color: red"
                v-tooltip="'Diferente a OCS'"
              ></span>
              <Badge
                v-show="slotProps.data.num_perifericos !== 0"
                :value="slotProps.data.num_perifericos"
                style="margin-left: 2px"
                v-tooltip="
                  'Con ' + slotProps.data.num_perifericos + ' periféricos'
                "
              >
              </Badge>
            </template>
          </Column>
        <Column
       
          field="Dispositivo"
       
          style="width: 35rem"
       
          header="DISPOSITIVO"
       
          :headerStyle="{ 'font-size': '12px' }"
       
          sortable
       
        >
       
          <template #body="slotProps">
       
            <div>
       
              <div style="display: flex;  width: 100%;">
       
                <strong>Tipo:</strong>
       
                <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
       
                  {{ slotProps.data.Tipo }}
       
                </span>
       
              </div>
       
              <div style="display: flex;  width: 100%;">
       
                <strong>Marca:</strong>
       
                <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
       
                  {{ slotProps.data.Marca }}
       
                </span>
       
              </div>
       
              <div style="display: flex;  width: 100%;">
       
                <strong>Modelo:</strong>
       
                <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
       
                  {{ slotProps.data.Modelo }}
       
                </span>
       
              </div>
       
              <div style="display: flex;  width: 100%;">
       
                <strong>SO:</strong>
       
                <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
       
                  {{ slotProps.data.SO }}
       
                </span>
       
              </div>
       
              <div style="display: flex;  width: 100%;">
       
                <strong>Serie:</strong>
       
                <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
       
                  {{ slotProps.data.Serie }}
       
                </span>
       
              </div>
       
            </div>
       
          </template>
       
        </Column>
       
       
       
        <Column
       
          field="InfoUsuario"
       
          style="width: 15rem"
       
          header="INFO USUARIO"
       
          :headerStyle="{ 'font-size': '12px' }"
       
          sortable
       
        >
       
          <template #body="slotProps">
       
            <div>
       
              <div style="display: inline-block; width: 100%;">
       
                <strong>Usuario:</strong>
       
                <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
       
                  {{ slotProps.data.Usuario }}
       
                </span>
       
              </div>
       
              <div style="display: inline-block; width: 100%;">
       
                <strong>Nombre:</strong>
       
                <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
       
                  {{ slotProps.data.Nombre_equipo }}
       
                </span>
       
              </div>
       
            </div>
       
          </template>
       
        </Column>
       
       
       
       
       
        <Column
       
          field="Descripcion"
       
          style="width: 15rem"
       
          header="DESCRIPCION"
       
          :headerStyle="{ 'font-size': '12px' }"
       
          sortable
       
        ></Column>
       
       
       
        <Column  
          field="Locacion"
          style="width: 15rem"
          header="LOCACION"
          :headerStyle="{ 'font-size': '12px' }"
          sortable
        >
          <template #body="slotProps">
            <div>
              <div style="display: inline-block; width: 100%;">
                <strong>Ubicación:</strong>
                <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  {{ slotProps.data.Ubicacion }}
                </span>
              </div>
              <div style="display: inline-block; width: 100%;">
                <strong>Área:</strong>
                <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  {{ slotProps.data.Area }}
                </span>
              </div>
            </div>
          </template>
        </Column>
        <Column
          field="Red"
          style="width: 15rem"
          header="RED"
          :headerStyle="{ 'font-size': '12px' }"
          sortable
        >
          <template #body="slotProps">
            <div>
              <div style="display: inline-block; width: 100%;">
                <strong>MAC:</strong>
                <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  {{ slotProps.data.MAC }}
                </span>
              </div>
              <div style="display: inline-block; width: 100%;">
                <strong>NNI:</strong>
                <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  {{ slotProps.data.NNI }}
                </span>
              </div>
            </div>
          </template>
        </Column>        
          <Column
            field="Fecha_registro"
            style="width: 15rem"
            header="FECHA REGISTRO"
            :headerStyle="{ 'font-size': '12px' }"
            sortable
          >
            <template #body="slotProps">
              {{ getFechaWCF(slotProps.data.Fecha_registro, true) }}
            </template>
          </Column>
          <Column
            field="Fecha_mod"
            style="width: 15rem"
            header="FECHA MODIFICACION"
            :headerStyle="{ 'font-size': '12px' }"
            sortable
          >
            <template #body="slotProps">
              {{ getFechaWCF(slotProps.data.Fecha_mod, true) }}
            </template>
          </Column>
          <Column
            field="Observaciones"
            style="width: 15rem"
            header="OBSERVACIONES"
            :headerStyle="{ 'font-size': '12px' }"
            sortable
          >
             <template #body="slotProps">
              <div
                v-if="
                  slotProps.data.DatosOCS &&
                  slotProps.data.DatosInventario &&
                  equiposOCS(slotProps.data)
                "
              >
                {{ slotProps.data.DatosInventario.Observacion }}
              </div>
              <div v-else>
                {{ slotProps.data.Observaciones }}
              </div>
            </template>
          </Column>
          <template #expansion="slotProps">
            <TabView>
              <TabPanel
                v-if="mostrarPerifericos(slotProps.data)"
                header="Periféricos"
              >
                <Button
                  label="Nuevo periferico"
                  icon="pi pi-plus"
                  class="p-button-success mr-2 mb-2"
                  :disabled="slotProps.data.Id_equipo_computo == 0"
                  @click="agregarPeriferico(slotProps.data)"
                />
                <DataTable
                  :value="slotProps.data.lstPerifericos"
                  v-model:expandedRows="expandedRowsPerifericosSegmentados"
                  dataKey="Id_equipo_periferico"
                  v-model:filters="filtersPerifericos1"
                  :globalFilterFields="[
                    'IP',
                    'Tipo',
                    'Marca',
                    'Modelo',
                    'Serie',
                    'NNI',
                    'MAC',
                    'Fecha_registro',
                    'Fecha_instalacion',
                    'Observaciones',
                  ]"
                  :loading="loadingPerifericos"
                  scrollable
                  responsiveLayout="scroll"
                  scrollDirection="both"
                  scrollHeight="300px"
                >
                  <template #empty> No se encontraron registros. </template>
                  <template #loadingPerifericos>
                    Cargando datos. Espere por favor.
                  </template>
                  <Column
                    field="BotonesPerifericos"
                    style="width: 6rem"
                    :headerStyle="{
                      'background-color': '#6495ED',
                      color: '#fff',
                      'font-size': '9px',
                    }"
                  >
                    <template #body="slotProps">
                      <div class="botones-container">
                        <Button
                          style="width: 30px; height: 30px; margin-right: 0px"
                          icon="pi pi-pencil"
                          class="p-button-rounded p-button-info"
                          @click="editarPeriferico(slotProps.data)"
                        />
                        <Button
                          style="width: 30px; height: 30px; margin-right: 0px"
                          icon="pi pi-times"
                          class="p-button-rounded p-button-warning"
                          @click="eliminarPeriferico(slotProps.data)"
                        />
                      </div>
                    </template>
                  </Column>
                  <Column
                    field="IP"
                    style="width: 10rem"
                    header="IP"
                    :headerStyle="{
                      'background-color': '#6495ED',
                      color: '#fff',
                      'font-size': '9px',
                    }"
                    sortable
                  ></Column>
                  <Column
                  field="Dispositivo"
                  style="width: 35rem"
                  header="DISPOSITIVO"
                  :headerStyle="{ 'font-size': '12px' }"
                  sortable
                >
                  <template #body="slotProps">
                    <div>
                      <div style="display: flex;  width: 100%;">
                        <strong>Tipo:</strong>
                        <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                          {{ slotProps.data.Tipo }}
                        </span>
                      </div>
                      <div style="display: flex;  width: 100%;">
                        <strong>Marca:</strong>
                        <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                          {{ slotProps.data.Marca }}
                        </span>
                      </div>
                      <div style="display: flex;  width: 100%;">
                        <strong>Modelo:</strong>
                        <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                          {{ slotProps.data.Modelo }}
                        </span>
                      </div>
                      <div style="display: flex;  width: 100%;">
                        <strong>SO:</strong>
                        <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                          {{ slotProps.data.SO }}
                        </span>
                      </div>
                      <div style="display: flex;  width: 100%;">
                        <strong>Serie:</strong>
                        <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                          {{ slotProps.data.Serie }}
                        </span>
                      </div>
                    </div>
                  </template>
                  </Column>
                  <Column

  field="InfoUsuario"
  style="width: 15rem"
  header="INFO USUARIO"
  :headerStyle="{ 'font-size': '12px' }"
  sortable
>
  <template #body="slotProps">
    <div>
      <div style="display: inline-block; width: 100%;">
        <strong>Usuario:</strong>
        <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          {{ slotProps.data.Usuario }}
        </span>
      </div>
      <div style="display: inline-block; width: 100%;">
        <strong>Nombre:</strong>
        <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          {{ slotProps.data.Nombre_equipo }}
        </span>
      </div>
    </div>
  </template>
</Column>
<Column
  field="Descripcion"
  style="width: 15rem"
  header="DESCRIPCION"
  :headerStyle="{ 'font-size': '12px' }"
  sortable
></Column>
<Column
  field="Locacion"
  style="width: 15rem"
  header="LOCACION"
  :headerStyle="{ 'font-size': '12px' }"
  sortable
>
  <template #body="slotProps">
    <div>
      <div style="display: inline-block; width: 100%;">
        <strong>Ubicación:</strong>
        <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          {{ slotProps.data.Ubicacion }}
        </span>
      </div>
      <div style="display: inline-block; width: 100%;">
        <strong>Área:</strong>
        <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          {{ slotProps.data.Area }}
        </span>
      </div>
    </div>
  </template>
</Column>
<Column
  field="Red"
  style="width: 15rem"
  header="RED"
  :headerStyle="{ 'font-size': '12px' }"
  sortable
>
  <template #body="slotProps">
    <div>
      <div style="display: inline-block; width: 100%;">
        <strong>MAC:</strong>
        <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          {{ slotProps.data.MAC }}
        </span>
      </div>
      <div style="display: inline-block; width: 100%;">
        <strong>NNI:</strong>
        <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          {{ slotProps.data.NNI }}
        </span>
      </div>
    </div>
  </template>
</Column>
<Column
  field="Fecha_registro"
  style="width: 15rem"
  header="FECHA REGISTRO"
  :headerStyle="{ 'font-size': '12px' }"
  sortable
>
  <template #body="slotProps">
    {{ getFechaWCF(slotProps.data.Fecha_registro, true) }}
  </template>
</Column>
<Column
  field="Fecha_mod"
  style="width: 15rem"
  header="FECHA MODIFICACION"
  :headerStyle="{ 'font-size': '12px' }"
  sortable
>
  <template #body="slotProps">
    {{ getFechaWCF(slotProps.data.Fecha_mod, true) }}
  </template>
</Column>
<Column
  field="Observaciones"
  style="width: 15rem"
  header="OBSERVACIONES"
  :headerStyle="{ 'font-size': '12px' }"
  sortable
></Column>
                </DataTable>
              </TabPanel>
              <TabPanel header="Información OCS">
                <Card :style="{ height: '350px', width: '750px' }">
                  <template #content>
                    <div class="grid">
                      <div class="col-6">
                        <div class="grid">
                          <div class="col title">IP</div>
                          <div class="col data">
                            {{
                              slotProps.data.DatosOCS
                                ? slotProps.data.DatosOCS.IP
                                : ""
                            }}
                          </div>
                        </div>
                        <div class="grid">
                          <div class="col title">USER</div>
                          <div class="col data">
                            {{
                              slotProps.data.DatosOCS
                                ? slotProps.data.DatosOCS.USERID
                                : ""
                            }}
                          </div>
                        </div>
                        <div class="grid">
                          <div class="col title">NOMBRE</div>
                          <div class="col data">
                            {{
                              slotProps.data.DatosOCS
                                ? slotProps.data.DatosOCS.NOMBRE
                                : ""
                            }}
                          </div>
                        </div>
                        <div class="grid">
                          <div class="col title">MAC</div>
                          <div class="col data">
                            {{
                              slotProps.data.DatosOCS
                                ? slotProps.data.DatosOCS.MAC
                                : ""
                            }}
                          </div>
                        </div>
                        <div class="grid">
                          <div class="col title">SSN</div>
                          <div class="col data">
                            {{
                              slotProps.data.DatosOCS
                                ? slotProps.data.DatosOCS.SSN
                                : ""
                            }}
                          </div>
                        </div>
                        <div class="grid">
                          <div class="col title">MANUFACTURER</div>
                          <div class="col data">
                            {{
                              slotProps.data.DatosOCS
                                ? slotProps.data.DatosOCS.SMANUFACTURER
                                : ""
                            }}
                          </div>
                        </div>
                        <div class="grid">
                          <div class="col title">DESCRIPCIÓN</div>
                          <div class="col data">
                            {{
                              slotProps.data.DatosOCS
                                ? slotProps.data.DatosOCS.DESCRIPTION
                                : ""
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="grid">
                          <div class="col title">TIPO</div>
                          <div class="col data">
                            {{
                              slotProps.data.DatosOCS
                                ? slotProps.data.DatosOCS.TIPO
                                : ""
                            }}
                          </div>
                        </div>
                        <div class="grid">
                          <div class="col title">OSNAME</div>
                          <div class="col data">
                            {{
                              slotProps.data.DatosOCS
                                ? slotProps.data.DatosOCS.OSNAME
                                : ""
                            }}
                          </div>
                        </div>
                        <div class="grid">
                          <div class="col title">MEMORY</div>
                          <div class="col data">
                            {{
                              slotProps.data.DatosOCS
                                ? slotProps.data.DatosOCS.MEMORY
                                : ""
                            }}
                          </div>
                        </div>
                        <div class="grid">
                          <div class="col title">PROCESSORT</div>
                          <div class="col data">
                            {{
                              slotProps.data.DatosOCS
                                ? slotProps.data.DatosOCS.PROCESSORT
                                : ""
                            }}
                          </div>
                        </div>
                        <div class="grid">
                          <div class="col title">ID</div>
                          <div class="col data">
                            {{
                              slotProps.data.DatosOCS
                                ? slotProps.data.DatosOCS.ID
                                : ""
                            }}
                          </div>
                        </div>
                        <div class="grid">
                          <div class="col title">MODEL</div>
                          <div class="col data">
                            {{
                              slotProps.data.DatosOCS
                                ? slotProps.data.DatosOCS.SMODEL
                                : ""
                            }}
                          </div>
                        </div>
                        <div class="grid">
                          <div class="col title">
                            FECHA DE ÚLTIMA SINCRONIZACIÓN
                          </div>
                          <div class="col data">
                            {{
                              slotProps.data.DatosOCS
                                ? getFechaWCF(slotProps.data.DatosOCS.DATE)
                                : ""
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </Card>
              </TabPanel>
            </TabView>
          </template>
          <template #footer>
            Registros en total {{ lstEquipos ? lstEquipos.length : 0 }}
          </template>
        </DataTable>
      </TabPanel>
      <TabPanel header="Equipos No Segmentados" :disabled="loadingTab2">
        <DataTable
          v-if="selectedUnidadFiltro && selectedUnidadFiltro.UNIDAD != ''"
          :value="lstEquipos"
          v-model:expandedRows="expandedRowsNoSegmentados"
          dataKey="Id_equipo_computo"
          @rowExpand="onRowExpand"
          v-model:filters="filtersNoSegmentados"
          :globalFilterFields="[
            'Unidad',
            'Ubicacion',
            'Usuario',
            'Serie',
            'SO',
            'Nombre_equipo',
            'NNI',
            'Area',
            'Observaciones',
            'Descripcion',
            'Marca',
            'MAC',
            'Modelo',
            'Tipo',
            'Fecha_mod',
            'Fecha_registro',
          ]"
          :loading="loadingEquiposNoSegmentados"
          scrollable
          responsiveLayout="scroll"
          scrollDirection="both"
          scrollHeight="550px"
        >
          <template #header>
            <div class="table-header">
              <h5>Equipos</h5>
              <span
                >Número de equipos
                {{ lstEquipos ? lstEquipos.length : 0 }}</span
              >
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  v-model="filtersNoSegmentados['global'].value"
                  placeholder="Buscar..."
                />
              </span>
            </div>
          </template>
          <template #empty> No se encontraron registros. </template>
          <template #loadingEquiposNoSegmentados>
            Cargando datos. Espere por favor.
          </template>
          <Column :expander="true" style="width: 4rem" />
          <Column field="Botones" style="width: 6rem">
            <template #body="slotProps">
              <Button
                style="width: 30px; height: 30px; margin-right: 0px"
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success"
                @click="editarEquipoNoSegmentado(slotProps.data)"
              />
              <Button
                style="width: 30px; height: 30px; margin-right: 0px"
                icon="pi pi-times"
                class="p-button-rounded p-button-danger"
                @click="borrarEquipoNoSegmentado(slotProps.data)"
              />
            </template>
          </Column>
          <Column
            field="Tipo"
            style="width: 15rem"
            header="TIPO"
            :headerStyle="{ 'font-size': '12px' }"
            sortable
          >
          </Column>
          <Column
            field="Usuario"
            style="width: 15rem"
            :headerStyle="{ 'font-size': '12px' }"
            header="USUARIO"
            sortable
          ></Column>
          <Column
            field="Nombre_equipo"
            style="width: 15rem"
            :headerStyle="{ 'font-size': '12px' }"
            header="NOMBRE"
            sortable
          ></Column>
          <Column
            field="Descripcion"
            style="width: 15rem"
            header="DESCRIPCION"
            :headerStyle="{ 'font-size': '12px' }"
            sortable
          ></Column>
          <Column
            field="Marca"
            style="width: 12rem"
            :headerStyle="{ 'font-size': '12px' }"
            header="MARCA"
            sortable
          ></Column>
          <Column
            field="Modelo"
            style="width: 10rem"
            :headerStyle="{ 'font-size': '12px' }"
            header="MODELO"
            sortable
          ></Column>
          <Column
            field="SO"
            style="width: 10rem"
            :headerStyle="{ 'font-size': '12px' }"
            header="SO"
            sortable
          ></Column>
          <Column
            field="Serie"
            style="width: 10rem"
            :headerStyle="{ 'font-size': '12px' }"
            header="SERIE"
            sortable
          ></Column>
          <Column
            field="Ubicacion"
            style="width: 15rem"
            :headerStyle="{ 'font-size': '12px' }"
            header="UBICACION"
            sortable
          ></Column>
          <Column
            field="Area"
            style="width: 15rem"
            :headerStyle="{ 'font-size': '12px' }"
            header="AREA"
            sortable
          ></Column>
          <Column
            field="MAC"
            style="width: 10rem"
            :headerStyle="{ 'font-size': '12px' }"
            header="MAC"
            sortable
          ></Column>
          <Column
            field="NNI"
            style="width: 10rem"
            :headerStyle="{ 'font-size': '12px' }"
            header="NNI"
            sortable
          ></Column>
          <Column
            field="Fecha_registro"
            style="width: 15rem"
            :headerStyle="{ 'font-size': '12px' }"
            header="FECHA REGISTRO"
            sortable
          >
            <template #body="slotProps">
              {{ getFechaWCF(slotProps.data.Fecha_registro, true) }}
            </template>
          </Column>
          <Column
            field="Fecha_mod"
            style="width: 15rem"
            :headerStyle="{ 'font-size': '12px' }"
            header="FECHA MODIFICACION"
            sortable
          >
            <template #body="slotProps">
              {{ getFechaWCF(slotProps.data.Fecha_mod, true) }}
            </template>
          </Column>
          <Column
            field="Observaciones"
            style="width: 15rem"
            :headerStyle="{ 'font-size': '12px' }"
            header="OBSERVACIONES"
            sortable
          ></Column>
          <template #expansion="slotProps">
            <TabView>
              <TabPanel header="Periféricos">
                <Button
                  label="Nuevo periférico"
                  icon="pi pi-plus"
                  class="p-button-success mr-2 mb-2"
                  @click="agregarPeriferico(slotProps.data)"
                />
                <DataTable
                  :value="slotProps.data.lstPerifericos"
                  v-model:expandedRows="expandedRowsPerifericosNoSegmentados"
                  dataKey="Id_equipo_periferico"
                  v-model:filters="filtersPerifericos2"
                  :globalFilterFields="[
                    'IP',
                    'Tipo',
                    'Marca',
                    'Modelo',
                    'Serie',
                    'NNI',
                    'MAC',
                    'Fecha_registro',
                    'Fecha_instalacion',
                    'Observaciones',
                  ]"
                  :loading="loadingPerifericos"
                  scrollable
                  responsiveLayout="scroll"
                  scrollDirection="both"
                  scrollHeight="300px"
                >
                  <template #empty> No se encontraron registros. </template>
                  <template #loadingPerifericos>
                    Cargando datos. Espere por favor.
                  </template>
                  <Column
                    field="BotonesPerifericos"
                    style="width: 10rem"
                    :headerStyle="{
                      'background-color': '#6495ED',
                      color: '#fff',
                      'font-size': '9px',
                    }"
                  >
                    <template #body="slotProps">
                      <Button
                        style="width: 30px; height: 30px; margin-right: 0px"
                        icon="pi pi-pencil"
                        class="p-button-rounded p-button-info"
                        @click="editarPeriferico(slotProps.data)"
                      />
                      <Button
                        style="width: 30px; height: 30px; margin-right: 0px"
                        icon="pi pi-times"
                        class="p-button-rounded p-button-warning"
                        @click="eliminarPeriferico(slotProps.data)"
                      />
                    </template>
                  </Column>
                  <Column
                    field="IP"
                    style="width: 10rem"
                    header="IP"
                    :headerStyle="{
                      'background-color': '#6495ED',
                      color: '#fff',
                      'font-size': '9px',
                    }"
                    sortable
                  ></Column>
                  <Column
                    field="Tipo"
                    style="width: 10rem"
                    header="TIPO"
                    :headerStyle="{
                      'background-color': '#6495ED',
                      color: '#fff',
                      'font-size': '9px',
                    }"
                    sortable
                  ></Column>
                  <Column
                    field="Marca"
                    style="width: 12rem"
                    header="MARCA"
                    :headerStyle="{
                      'background-color': '#6495ED',
                      color: '#fff',
                      'font-size': '9px',
                    }"
                    sortable
                  ></Column>
                  <Column
                    field="Modelo"
                    style="width: 10rem"
                    header="MODELO"
                    :headerStyle="{
                      'background-color': '#6495ED',
                      color: '#fff',
                      'font-size': '9px',
                    }"
                    sortable
                  ></Column>
                  <Column
                    field="Serie"
                    style="width: 10rem"
                    header="SERIE"
                    :headerStyle="{
                      'background-color': '#6495ED',
                      color: '#fff',
                      'font-size': '9px',
                    }"
                    sortable
                  ></Column>
                  <Column
                    field="MAC"
                    style="width: 10rem"
                    header="MAC"
                    :headerStyle="{
                      'background-color': '#6495ED',
                      color: '#fff',
                      'font-size': '9px',
                    }"
                    sortable
                  ></Column>
                  <Column
                    field="NNI"
                    style="width: 10rem"
                    header="NNI"
                    :headerStyle="{
                      'background-color': '#6495ED',
                      color: '#fff',
                      'font-size': '9px',
                    }"
                    sortable
                  ></Column>
                  <Column
                    field="Fecha_registro"
                    style="width: 15rem"
                    header="FECHA DE REGISTRO"
                    :headerStyle="{
                      'background-color': '#6495ED',
                      color: '#fff',
                      'font-size': '9px',
                    }"
                    sortable
                    ><template #body="slotProps">
                      {{ getFechaWCF(slotProps.data.Fecha_registro, true) }}
                    </template>
                  </Column>
                  <Column
                    field="Fecha_mod"
                    style="width: 15rem"
                    header="FECHA DE MODIFICACIÓN"
                    :headerStyle="{
                      'background-color': '#6495ED',
                      color: '#fff',
                      'font-size': '9px',
                    }"
                    sortable
                  >
                    <template #body="slotProps">
                      {{ getFechaWCF(slotProps.data.Fecha_mod, true) }}
                    </template>
                  </Column>
                  <Column
                    field="Fecha_instalacion"
                    style="width: 15rem"
                    header="FECHA DE INSTALACIÓN"
                    :headerStyle="{
                      'background-color': '#6495ED',
                      color: '#fff',
                      'font-size': '9px',
                    }"
                    sortable
                  >
                    <template #body="slotProps">
                      {{ getFechaWCF(slotProps.data.Fecha_instalacion, true) }}
                    </template>
                  </Column>
                  <Column
                    field="Observaciones"
                    style="width: 15rem"
                    header="OBSERVACIONES"
                    :headerStyle="{
                      'background-color': '#6495ED',
                      color: '#fff',
                      'font-size': '9px',
                    }"
                    sortable
                  ></Column>
                </DataTable>
              </TabPanel>
            </TabView>
          </template>
          <template #footer>
            Registros en total {{ lstEquipos ? lstEquipos.length : 0 }}
          </template>
        </DataTable>
      </TabPanel>
    </TabView>

    <Dialog
      :style="{ width: '750px' }"
      :draggable="false"
      :visible="showAgregar"
      :modal="true"
      class="p-fluid"
      :closable="false"
      :resizable="false"
    >
   
      <template #header>
        <h3>{{ modoEdicion }} equipo</h3>
      </template>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="unidad">Unidad y Subred</label>
          <Dropdown
            id="unidad"
            appendTo="body"
            v-model="equipo.tUnidad"
            :options="lstUnidades"
            optionLabel="UNIDAD_SUBRED"
            placeholder="Selecciona una unidad"
            :filter="true"
            @change="escribeIP"
            :class="{
              'p-invalid': submitted && !equipo.tUnidad,
            }"
          />
          <small class="p-invalid" v-if="submitted && !equipo.tUnidad"
            >La unidad es requerida.</small
          >
        </div>

        <div class="p-field col">
          <label for="tipo">Tipo</label>
          <Dropdown
            id="tipo"
            appendTo="body"
            v-model="equipo.tTipo"
            :options="lstTipos"
            optionLabel="Tipo"
            placeholder="Selecciona un tipo o escribe uno nuevo"
            :class="{
              'p-invalid': submitted && !equipo.tTipo,
            }"
          />
          <small class="p-invalid" v-if="submitted && !equipo.tTipo"
            >El tipo es requerido.</small
          >
        </div>
      </div>

      <div class="p-field col">
        <div class="p-field-checkbox">
          <Checkbox
            id="NoSegmentado"
            name="NoSegmentado"
            :binary="true"
            v-model="NoSegmentado"
          />
          <label for="NoSegmentado"> Equipo no segmentado</label>
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="nombre">Nombre del Equipo</label>
          <InputText
            autocomplete="off"
            id="nombre"
            v-model.trim="equipo.Nombre_equipo"
            autofocus
          />
          <span
            v-if="
              equipo.DatosOCS &&
              equipo.DatosOCS.NAME &&
              equipo.DatosOCS.NAME.split('.')[0].toLowerCase() !=
              equipo.Nombre_equipo?.toLowerCase()"
            class="pi pi-info-circle ml-1"
            style="font-size: 1.2rem; color: red"
            v-tooltip="
              'Valor según OCS:\n' +
              equipo.DatosOCS?.NAME?.split('.')[0].toUpperCase() +
              '\n\nClic para cambiar'
            " @click="
              equipo.Nombre_equipo =
                equipo.DatosOCS?.NAME?.split('.')[0].toUpperCase() "
          ></span>
        </div>
        <div class="p-field col">
          <label for="ubicacion">Ubicación del Equipo</label>
          <InputText
            autocomplete="off"
            id="ubicacion"
            v-model.trim="equipo.Ubicacion"
            autofocus
          />
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="usuario">Usuario</label>
          <InputText
            autocomplete="off"
            id="usuario"
            v-model.trim="equipo.Usuario"
            required="true"
            autofocus
          />
          <span
            v-if="
              equipo.DatosOCS &&
              equipo.DatosOCS.USERID &&
              equipo.DatosOCS.USERID.toLowerCase() !=
              equipo.Usuario?.toLowerCase() "
            class="pi pi-info-circle ml-1"
            style="font-size: 1.2rem; color: red"
            v-tooltip="
              'Valor según OCS:\n' +
              equipo.DatosOCS?.USERID +
              '\n\nClic para cambiar'
"
            @click="equipo.Usuario = equipo.DatosOCS?.USERID"
          ></span>
        </div>
        <div class="p-field col">
          <label for="area">Área</label>
          <InputText
            autocomplete="off"
            id="area"
            v-model.trim="equipo.Area"
            autofocus
          />
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="marca">Marca</label>
          <InputText
            autocomplete="off"
            id="marca"
            v-model.trim="equipo.Marca"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !equipo.Marca }"
          />
          <small class="p-invalid" v-if="submitted && !equipo.Marca"
            >La marca es requerida.</small
          >
          <span
            v-if="
              equipo.DatosOCS &&
              equipo.DatosOCS.SMANUFACTURER &&
              equipo.DatosOCS.SMANUFACTURER.toLowerCase() !=
              equipo.Marca?.toLowerCase()
            "
            class="pi pi-info-circle ml-1"
            style="font-size: 1.2rem; color: red"
            v-tooltip="
              'Valor según OCS:\n' +
              equipo.DatosOCS?.SMANUFACTURER +
              '\n\nClic para cambiar'
            "
            @click="equipo.Marca = equipo.DatosOCS?.SMANUFACTURER"
          ></span>
        </div>
        <div class="p-field col">
          <label for="modelo">Modelo</label>
          <InputText
            autocomplete="off"
            id="modelo"
            v-model.trim="equipo.Modelo"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !equipo.Modelo }"
          />
          <small class="p-invalid" v-if="submitted && !equipo.Modelo"
            >El modelo es requerido.</small
          >
          <span
            v-if="
              equipo.DatosOCS &&
              equipo.DatosOCS.SMODEL &&
              equipo.DatosOCS.SMODEL.toLowerCase() !=
              equipo.Modelo?.toLowerCase()
            "
            class="pi pi-info-circle ml-1"
            style="font-size: 1.2rem; color: red"
            v-tooltip="
              'Valor según OCS:\n' +
              equipo.DatosOCS?.SMODEL +
              '\n\nClic para cambiar'
            "
            @click="equipo.Modelo = equipo.DatosOCS?.SMODEL"
          ></span>
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="serie">No. serie</label>
          <InputText
            autocomplete="off"
            id="serie"
            v-model.trim="equipo.Serie"
            required="true"
            autofocus
          />
          <span
            v-if="
              equipo.DatosOCS &&
              equipo.DatosOCS.SSN &&
              equipo.DatosOCS.SSN.toLowerCase() != equipo.Serie?.toLowerCase()
            "
            class="pi pi-info-circle ml-1"
            style="font-size: 1.2rem; color: red"
            v-tooltip="
                'Valor según OCS:\n' +
                equipo.DatosOCS?.SSN +
                '\n\nClic para cambiar'
              "
            @click="equipo.Serie = equipo.DatosOCS?.SSN"
          ></span>
        </div>
        <div class="p-field col">
          <label for="so">Sistema Operativo</label>
          <InputText
            autocomplete="off"
            id="so"
            v-model.trim="equipo.SO"
            required="true"
            autofocus
          />
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="p-field col" v-show="!NoSegmentado">
          <label for="ip">IP</label>
          <InputText
            autocomplete="off"
            id="ip"
            v-model.trim="equipo.IP"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !equipo.IP }"
          />
          <small class="p-invalid" v-if="submitted && !equipo.IP"
            >La IP es requerida.</small
          >
        </div>

        <div class="p-field col">
          <label for="nni">NNI</label>
          <InputText
            autocomplete="off"
            id="ref"
            v-model.trim="equipo.NNI"
            autofocus
          />
        </div>
      </div>
      <div class="p-field col">
        <label for="mac">MAC</label>
        <InputMask
          autocomplete="off"
          id="mac"
          v-model.trim="equipo.MAC"
          mask="**:**:**:**:**:**"
          autofocus
        />
        <span
            v-if="
              equipo.DatosOCS &&
              equipo.DatosOCS.MAC &&
              equipo.DatosOCS.MAC.toLowerCase() != equipo.MAC?.toLowerCase()
            "
            class="pi pi-info-circle ml-1"
            style="font-size: 1.2rem; color: red"
            v-tooltip="
              'Valor según OCS:\n' + equipo.DatosOCS?.MAC + '\n\nClic para cambiar'
            "
            @click="equipo.MAC = equipo.DatosOCS?.MAC"
          ></span>
      </div>
      <div class="p-field col">
        <label for="Descripcion">Descripción</label>
        <Textarea
          autocomplete="off"
          id="ref"
          v-model.trim="equipo.Descripcion"
          autofocus
          style="width: 100%; height: 70px;"
        />
      </div>
        <div class="p-field col">
          <label for="obs">Observaciones</label>
          <Textarea
            autocomplete="off"
            id="obs"
            v-model.trim="equipo.Observaciones"
            autofocus
            style="width: 100%; height: 70px;"
          />
      </div>

      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancelarDialogo"
        />
        <Button
          label="Guardar"
          icon="pi pi-check"
          class="p-button-text"
          @click="guardarEquipo"
        />
      </template>
    </Dialog>

    <Dialog
      :style="{ width: '550px' }"
      :visible="showAgregarPeriferico"
      :modal="true"
      class="p-fluid"
      :closable="false"
    >

   
      <template #header>
        <h3>{{ modoEdicion }} periférico</h3>
      </template>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="unidad">Unidad y Subred</label>
          <Dropdown
            id="unidad"
            appendTo="body"
            v-model="periferico.tUnidad"
            :options="lstUnidades"
            optionLabel="UNIDAD_SUBRED"
            placeholder="Selecciona una unidad"
            :filter="true"
            :class="{
              'p-invalid': submitted && !periferico.tUnidad,
            }"
          />
          <small class="p-invalid" v-if="submitted && !periferico.tUnidad"
            >La unidad es requerida.</small
          >
        </div>
        <div class="p-field col">
          <label for="tipoperiferico">Tipo</label>
          <Dropdown
            id="tipoperiferico"
            appendTo="body"
            v-model="periferico.tTipo"
            :options="lstTiposPerifericos"
            optionLabel="Tipo"
            placeholder="Selecciona un tipo o escribe uno nuevo"
            :class="{
              'p-invalid': submitted && !periferico.tTipo,
            }"
          />
          <small class="p-invalid" v-if="submitted && !periferico.tTipo"
            >El tipo es requerido.</small
          >
        </div>
      </div>

      <div class="p-field col">
        <label for="ipperiferico">IP</label>
        <InputText
          autocomplete="off"
          id="ipperiferico"
          v-model.trim="periferico.IP"
          autofocus
        />
      </div>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="marcaperiferico">Marca</label>
          <InputText
            autocomplete="off"
            id="marcaperiferico"
            v-model.trim="periferico.Marca"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !periferico.Marca }"
          />
          <small class="p-invalid" v-if="submitted && !periferico.Marca"
            >La marca es requerida.</small
          >
        </div>
        <div class="p-field col">
          <label for="modeloperiferico">Modelo</label>
          <InputText
            autocomplete="off"
            id="modeloperiferico"
            v-model.trim="periferico.Modelo"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !periferico.Modelo }"
          />
          <small class="p-invalid" v-if="submitted && !periferico.Modelo"
            >El modelo es requerido.</small
          >
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="serieperiferico">No. serie</label>
          <InputText
            autocomplete="off"
            id="serieperiferico"
            v-model.trim="periferico.Serie"
            required="true"
            autofocus
          />
        </div>
        <div class="p-field col">
          <label for="nni">NNI</label>
          <InputText
            autocomplete="off"
            id="ref"
            v-model.trim="periferico.NNI"
            autofocus
          />
        </div>
      </div>
      <div class="p-field col">
        <label for="mac">MAC</label>
        <InputMask
          autocomplete="off"
          id="ref"
          v-model.trim="periferico.MAC"
          mask="**:**:**:**:**:**"
          autofocus
        />
      </div>
      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="obs">Observaciones</label>
          <Textarea
            autocomplete="off"
            id="obs"
            v-model.trim="periferico.Observaciones"
            autofocus
          />
        </div>
      </div>

      <div class="field col-4 md:col-4">
        <label for="fecha_instalacion">Fecha de instalación</label>
        <Calendar
          id="fecha_instalacion"
          v-model="periferico.Fecha_instalacion"
          :value="periferico.Fecha_instalacion"
          dateFormat="mm-dd-yy"
          :class="{ 'p-invalid': submitted && !periferico.Fecha_instalacion }"
        />
        <small
          class="p-invalid"
          v-if="submitted && !periferico.Fecha_instalacion"
          >La fecha de instalación es requerida.</small
        >
      </div>
      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancelarDialogo"
        />
        <Button
          label="Guardar"
          icon="pi pi-check"
          class="p-button-text"
          @click="guardarPeriferico"
        />
      </template>
    </Dialog>
      <!--Dialog encargado de desplegar la ventana que vamos a estra trabajando-->
     
      <Dialog
    header="Listas de Verificación"
    v-model:visible="dialogVisible"
    :style="{ width: '70vw' }"  
    :draggable="false"
    :closable="false"
    :resizable="false"
    :modal="true"
    maximizable
    class="p-fluid"
    :contentStyle="{ height: '1000px', overflow: '800px', display: 'flex', flexDirection: 'column' }"
>
    <!-- Apartado de IP_Equipo y botón de Nueva Verificación -->
    <div class="col-12 flex justify-content-between align-items-center" v-if="!showNuevaVerificacion">
        <div>
            <span><strong>IP de Equipo:</strong> {{ evidencia.IP_equipo }}</span>
        </div>
        <div>
            <Button label="Nueva Verificación" icon="pi pi-plus" class="p-button-success" @click="mostrarNuevaVerificacion" />
        </div>
    </div>

    <!-- Primera pestaña: Lista verificación -->
    <div v-if="!showNuevaVerificacion">
        <DataTable
            :value="tableEvidencia"
            v-model:expandedRows="expandedRowsEvidencia"
            responsiveLayout="scroll"
            :dataKey="dataKey"
            :loading="loading"
            :modal="true"
        >
            <template #empty>No se encontraron registros.</template>
            <template #loading>Cargando datos. Espero por favor.</template>
            <Column field="Matricula_realizo" header="Matrícula" style=" width:150px; "></Column>
            <Column field="Nombres" header="Nombres" style=" width:300px; "></Column>
            <Column field="Fecha" header="Fecha de creación " sortable style=" width:180px; ">
                <template #body="slotProps">
                    {{ getFechaWCF(slotProps.data.Fecha, true) }}
                </template>
            </Column>
            <Column field="" header="" style="width:150px;">
                <template #body ="slotProps">
                    <Button label="Evidencias" outlined @click="mostrarDialogEvidencias(slotProps.data.Id_lista_verificacion)"/>
                </template>
            </Column>
        </DataTable>
    </div>

    <!-- Apartado de relleno de datos de la nueva verificación -->
    <div v-else>
        <div class="p-formgrid grid fixed-fields">
         
            <!-- Ocultar el campo IP equipo si es Nueva Verificación -->
            <div class="p-field col-2">
                <label for="ip_equipo">IP equipo</label>
                <InputText autocomplete="off" id="ip_equipo" v-model.trim="evidencia.IP_equipo" required="true" autofocus disabled="true" />
            </div>
            <div class="p-field col-2">
                <label for="matricula">Matrícula</label>
                <InputText autocomplete="off" id="matricula" v-model.trim="evidencia.Matricula_realizo" @blur="consultarEmpleado" required="true" :class="{'p-invalid': submitted && !evidencia.Matricula_realizo}" />
                <small class="p-invalid" v-if="submitted && !evidencia.Matricula_realizo">La matrícula es requerida.</small>
            </div>
            <div class="p-field col-6">
                <label for="nombres">Nombre</label>
                <InputText autocomplete="off" id="nombre" v-model.trim="evidencia.Nombres" readonly />
            </div>
            <!-- Nuevos Campos -->
            <div class="p-field col-2">
                <label for="fecha">Fecha</label>
                <InputText type="date" id="fecha" v-model.trim="evidencia.Fecha" required="true" :class="{'p-invalid': submitted && !evidencia.Fecha}" />
            </div>
            <div class="p-field col-2">
                <label for="referencia_red">Referencia de Red</label>
                <InputText autocomplete="off" id="referencia_red" v-model.trim="evidencia.Referencia_red" required="true" :class="{'p-invalid': submitted && !evidencia.Referencia_red}" />
                <small class="p-invalid" v-if="submitted && !evidencia.Referencia_red">La referencia de red es requerida.</small>
            </div>
            <div class="p-field col-4">
                <label for="unidad">Unidad</label>
                <InputText autocomplete="off" id="unidad" v-model.trim="evidencia.Unidad" required="true" :disabled="true" :class="{'p-invalid': submitted && !evidencia.Unidad}" />
                <small class="p-invalid" v-if="submitted && !evidencia.Unidad">La unidad es requerida.</small>
            </div>
            <div class="p-field col-3">
                <label for="area">Área</label>
                <InputText autocomplete="off" id="area" v-model.trim="evidencia.Area" required="true" :class="{'p-invalid': submitted && !evidencia.Area}" />
                <small class="p-invalid" v-if="submitted && !evidencia.Area">El área es requerida.</small>
            </div>
            <div class="p-field col-3">
                <label for="usuario">Usuario</label>
                <InputText autocomplete="off" id="usuario" v-model.trim="evidencia.Usuario" required="true" :class="{'p-invalid': submitted && !evidencia.Usuario}" />
                <small class="p-invalid" v-if="submitted && !evidencia.Usuario">El usuario es requerido.</small>
            </div>
        </div>
        <div class="scrollable-content">
            <div id="app" class="root">
                <div class="wrapper-list">
                    <h2>Los controles a revisar son:</h2>
                </div>
            </div>

            <Accordion class= "highlight-title" :activeIndex="activeAccordionIndex1">
                <AccordionTab header="Equipos ingresados a Dominio/Directorio Activo">
                    <div class="m-0">
                        <div v-for="(fileItem, index) in fileUploadsAccordion1" :key="index" class="file-upload-container">
                            <Button
                                v-if="index !== 0"
                                icon="pi pi-minus"
                                class="p-button-rounded p-button-text p-button-danger"
                                @click="removeFileUpload(index, 'fileUploadsAccordion1')"
                                aria-label="Eliminar componente"
                            />
                            <div class="p-field col-3">
                                <FileUpload
                                    :ref="'fileUploadRef1' + index"
                                    mode="basic"
                                    name="fil1"
                                    url="/api/upload"
                                    accept="image/*"
                                    :maxFileSize="5000000"
                                    @select="(event) => onFileSelect(event, index, 'fileUploadsAccordion1')"
                                    @upload="onUpload"
                                />
                            </div>

                            <div v-if="fileItem.imageUrl" class="image-preview-container">
                                <div class="image-preview">
                                    <img :src="fileItem.imageUrl" alt="Vista previa" />
                                </div>
                                <div class="image-info">
                                    <label><strong>Observaciones</strong></label>
                                    <Textarea
                                        autocomplete="true"
                                        id="observaciones"
                                        v-model.trim="fileItem.Observaciones"
                                        required="true"
                                        autofocus
                                        rows="5"
                                        cols="20"
                                        placeholder="Escribe aquí tus observaciones..."
                                    />
                                    <Button
                                        icon="pi pi-times"
                                        class="p-button-rounded p-button-text p-button-danger"
                                        @click="removeImage(index, 'fileUploadsAccordion1')"
                                        aria-label="Eliminar imagen"
                                        style="position: absolute; right: 0; bottom: 0;"
                                    />
                                </div>
                            </div>
                        </div>

                        <Button
                            icon="pi pi-plus"
                            class="p-button-rounded p-button-text p-button-success"
                            @click="addFileUpload('fileUploadsAccordion1')"
                            aria-label="Agregar nuevo archivo"
                            :disabled="fileUploadsAccordion1.length >= 4"
                        />
                    </div>
                </AccordionTab>
            </Accordion>
             <!-- Segundo Acordeon -->
        <Accordion class= "highlight-title1" :activeIndex="activeAccordionIndex2">
          <AccordionTab header="Protección Antivirus y Antimalware">
            <div class="m-0">
              <div v-for="(fileItem, index) in fileUploadsAccordion2" :key="index" class="file-upload-container">
                <Button
                  v-if="index !== 0"
                  icon="pi pi-minus"
                  class="p-button-rounded p-button-text p-button-danger"
                  @click="removeFileUpload(index, 'fileUploadsAccordion2')"
                  aria-label="Eliminar componente"
                />

                <div class="p-field col-3">
                  <FileUpload
                    :ref="'fileUploadRef2' + index"
                    mode="basic"
                    name="demo[]"
                    url="/api/upload"
                    accept="image/*"
                    :maxFileSize="5000000"
                    @select="(event) => onFileSelect(event, index, 'fileUploadsAccordion2')"  
                    @upload="onUpload"
                  />
                </div>

                <div v-if="fileItem.imageUrl" class="image-preview-container">
                  <div class="image-preview">
                    <img :src="fileItem.imageUrl" alt="Vista previa" />
                  </div>
                  <div class="image-info">
                    <label><strong>Observaciones</strong></label>
                    <Textarea
                      autocomplete="true"
                      id="observaciones"
                      v-model.trim="fileItem.Observaciones"
                      required="true"
                      autofocus
                      rows="5"
                      cols="20"
                      placeholder="Escribe aquí tus observaciones..."
                    />
                    <Button
                      icon="pi pi-times"
                      class="p-button-rounded p-button-text p-button-danger"
                      @click="removeImage(index, 'fileUploadsAccordion2')"  
                      aria-label="Eliminar imagen"
                      style="position: absolute; right: 0; bottom: 0;"
                    />
                  </div>
                </div>
              </div>

              <Button
                icon="pi pi-plus"
                class="p-button-rounded p-button-text p-button-success"
                @click="addFileUpload('fileUploadsAccordion2')"
                aria-label="Agregar nuevo archivo"
                :disabled="fileUploadsAccordion2.length >= 4"
              />
            </div>
          </AccordionTab>
        </Accordion>

        <!--Tercer acordeón-->
        <Accordion class= "highlight-title2" :activeIndex="activeAccordionIndex3">
          <AccordionTab header="Parches de seguridad del virus">
            <div class="m-0">
              <div v-for="(fileItem, index) in fileUploadsAccordion3" :key="index" class="file-upload-container">
                <Button
                  v-if="index !== 0"
                  icon="pi pi-minus"
                  class="p-button-rounded p-button-text p-button-danger"
                  @click="removeFileUpload(index, 'fileUploadsAccordion3')"
                  aria-label="Eliminar componente"
                />

                <div class="p-field col-3">
                  <FileUpload
                    :ref="'fileUploadRef3' + index"
                    mode="basic"
                    name="demo[]"
                    url="/api/upload"
                    accept="image/*"
                    :maxFileSize="5000000"
                    @select="(event) => onFileSelect(event, index, 'fileUploadsAccordion3')"  
                    @upload="onUpload"
                  />
                </div>

                <div v-if="fileItem.imageUrl" class="image-preview-container">
                  <div class="image-preview">
                    <img :src="fileItem.imageUrl" alt="Vista previa" />
                  </div>
                  <div class="image-info">
                    <label><strong>Observaciones</strong></label>
                    <Textarea
                      autocomplete="true"
                      id="observaciones"
                      v-model.trim="fileItem.Observaciones"
                      required="true"
                      autofocus
                      rows="5"
                      cols="20"
                      placeholder="Escribe aquí tus observaciones..."
                    />
                    <Button
                      icon="pi pi-times"
                      class="p-button-rounded p-button-text p-button-danger"
                      @click="removeImage(index, 'fileUploadsAccordion3')"  
                      aria-label="Eliminar imagen"
                      style="position: absolute; right: 0; bottom: 0;"
                    />
                  </div>
                </div>
              </div>

              <Button
                icon="pi pi-plus"
                class="p-button-rounded p-button-text p-button-success"
                @click="addFileUpload('fileUploadsAccordion3')"
                aria-label="Agregar nuevo archivo"
                :disabled="fileUploadsAccordion3.length >= 4"
              />
            </div>
          </AccordionTab>
        </Accordion>

        <!--Cuarto acordeón-->
        <Accordion class= "highlight-title3" :activeIndex="activeAccordionIndex4">
          <AccordionTab header="Existencia de cuentas predeterminadas o genéricas">
            <div class="m-0">
              <div v-for="(fileItem, index) in fileUploadsAccordion4" :key="index" class="file-upload-container">
                <Button
                  v-if="index !== 0"
                  icon="pi pi-minus"
                  class="p-button-rounded p-button-text p-button-danger"
                  @click="removeFileUpload(index, 'fileUploadsAccordion4')"
                  aria-label="Eliminar componente"
                />

                <div class="p-field col-3">
                  <FileUpload
                    :ref="'fileUploadRef4' + index"
                    mode="basic"
                    name="demo[]"
                    url="/api/upload"
                    accept="image/*"
                    :maxFileSize="5000000"
                    @select="(event) => onFileSelect(event, index, 'fileUploadsAccordion4')"  
                    @upload="onUpload"
                  />
                </div>

                <div v-if="fileItem.imageUrl" class="image-preview-container">
                  <div class="image-preview">
                    <img :src="fileItem.imageUrl" alt="Vista previa" />
                  </div>
                  <div class="image-info">
                    <label><strong>Observaciones</strong></label>
                    <Textarea
                      autocomplete="true"
                      id="observaciones"
                      v-model.trim="fileItem.Observaciones"
                      required="true"
                      autofocus
                      rows="5"
                      cols="20"
                      placeholder="Escribe aquí tus observaciones..."
                    />
                    <Button
                      icon="pi pi-times"
                      class="p-button-rounded p-button-text p-button-danger"
                      @click="removeImage(index, 'fileUploadsAccordion4')"  
                      aria-label="Eliminar imagen"
                      style="position: absolute; right: 0; bottom: 0;"
                    />
                  </div>
                </div>
              </div>

              <Button
                icon="pi pi-plus"
                class="p-button-rounded p-button-text p-button-success"
                @click="addFileUpload('fileUploadsAccordion4')"
                aria-label="Agregar nuevo archivo"
                :disabled="fileUploadsAccordion4.length >= 4"
              />
            </div>
          </AccordionTab>
        </Accordion>

        <!--Quinto Acordeón-->
        <Accordion class= "highlight-title4" :activeIndex="activeAccordionIndex5">
          <AccordionTab header="Servicio institucional de Internet">
            <div class="m-0">
              <div v-for="(fileItem, index) in fileUploadsAccordion5" :key="index" class="file-upload-container">
                <Button
                  v-if="index !== 0"
                  icon="pi pi-minus"
                  class="p-button-rounded p-button-text p-button-danger"
                  @click="removeFileUpload(index, 'fileUploadsAccordion5')"
                  aria-label="Eliminar componente"
                />

                <div class="p-field col-3">
                  <FileUpload
                    :ref="'fileUploadRef5' + index"
                    mode="basic"
                    name="demo[]"
                    url="/api/upload"
                    accept="image/*"
                    :maxFileSize="5000000"
                    @select="(event) => onFileSelect(event, index, 'fileUploadsAccordion5')"  
                    @upload="onUpload"
                  />
                </div>

                <div v-if="fileItem.imageUrl" class="image-preview-container">
                  <div class="image-preview">
                    <img :src="fileItem.imageUrl" alt="Vista previa" />
                  </div>
                  <div class="image-info">
                    <label><strong>Observaciones</strong></label>
                    <Textarea
                      autocomplete="true"
                      id="observaciones"
                      v-model.trim="fileItem.Observaciones"
                      required="true"
                      autofocus
                      rows="5"
                      cols="20"
                      placeholder="Escribe aquí tus observaciones..."
                    />
                    <Button
                      icon="pi pi-times"
                      class="p-button-rounded p-button-text p-button-danger"
                      @click="removeImage(index, 'fileUploadsAccordion5')"  
                      aria-label="Eliminar imagen"
                      style="position: absolute; right: 0; bottom: 0;"
                    />
                  </div>
                </div>
              </div>

              <Button
                icon="pi pi-plus"
                class="p-button-rounded p-button-text p-button-success"
                @click="addFileUpload('fileUploadsAccordion5')"
                aria-label="Agregar nuevo archivo"
                :disabled="fileUploadsAccordion5.length >= 4"
              />
            </div>
          </AccordionTab>
        </Accordion>
        </div>
    </div>
    <template #footer>
        <div v-if="!showNuevaVerificacion">
            <Button label="Cancelar" icon="pi pi-times" class="p-button-text" @click="cancelarDialogo" />
        </div>
        <!-- Footer para Nueva Verificación -->
        <div v-else>
            <Button label="Guardar" icon="pi pi-check" class="p-button-text" @click="agregarEvidencia" />
            <Button label="Cancelar" icon="pi pi-times" class="p-button-text" @click="cancelarverificacion" />
        </div>
    </template>
</Dialog>
<Dialog
    header="Evidencias"
    v-model:visible="dialogEvidenciasVisible"
    :style="{ width: '70vw' }"  
    :draggable="false"
    :closable="false"
    :resizable="false"
    :modal="true"
    maximizable
    class="p-fluid"
    :contentStyle="{ height: '1000px', overflow: '800px', display: 'flex', flexDirection: 'column' }"  
  >
 <!-- Sección de Evidencias -->
<div class="custom-footer custom-footer-large" id="footer-primary">
  <!-- Contenido del primer contenedor -->
  <div class="opacity-box">
    <div class="p-field p-flex">
      <!-- Primera fila -->
      <div class="row row-first">
          <h6 class="field-item"><strong>IP del Equipo:</strong> {{ evidencia.IP_equipo }}</h6>
          <h6 class="field-item"><strong>Matrícula:</strong> {{ evidencia.Matricula_realizo }}</h6>
          <h6 class="field-item"><strong>Usuario:</strong> {{ evidencia.Usuario }}</h6>
          <h6 class="field-item"><strong>Nombres:</strong> {{ evidencia.Nombres }}</h6>
      </div>

      <!-- Segunda fila -->
      <div class="row row-second">
          <h6 class="field-item"><strong>Unidad:</strong> {{ evidencia.Unidad }}</h6>
          <h6 class="field-item"><strong>Área:</strong> {{ evidencia.Area }}</h6>
          <h6 class="field-item"><strong>Referencia de Red:</strong> {{ evidencia.Referencia_red }}</h6>
          <h6 class="field-item"><strong>Fecha de Creación:</strong> {{ fechaEvidencia }}</h6 >
      </div>
    </div>
  </div>
</div>



    <!-- Sección de Tablas y Flex Scroll -->
    <div class="opacity-box">
    <div class="scrollable-content" style="flex-grow: 1; overflow-y: auto;">
      <div id="app" class="root">
        <div class="wrapper-list">
          <h5 class="highlight-title">Equipos ingresados a Dominio/ Directorio Activo</h5>
<DataTable :value="productsTipo1" tableStyle="min-width: 650px">
  <Column field="Observaciones" header="Observaciones"></Column>
  <Column field="Imagen" header="Imagen" style="width: 120px;">
    <template #body="slotProps">
      <Image :src="concatenarImagen(slotProps.data.Imagen)" alt="Imagen de evidencia"
      width="100"
      preview
      class="preview-image"
      @click="showFullImage(slotProps.data.Imagen)" />
    </template>
  </Column>
</DataTable>

<h5 class="highlight-title1">Protección Antivirus y Antimalware</h5>
<DataTable :value="productsTipo2" tableStyle="min-width: 650px">
  <Column field="Observaciones" header="Observaciones"></Column>
  <Column field="Imagen" header="Imagen" style="width: 120px;">
    <template #body="slotProps">
      <Image :src="concatenarImagen(slotProps.data.Imagen)"  alt="Imagen de evidencia"
      width="100"
      preview
      class="preview-image"
      @click="showFullImage(slotProps.data.Imagen)"/>
    </template>
  </Column>
</DataTable>

<h5 class="highlight-title2">Parches de seguridad del antivirus</h5>
<DataTable :value="productsTipo3" tableStyle="min-width: 650px">
  <Column field="Observaciones" header="Observaciones"></Column>
  <Column field="Imagen" header="Imagen" style="width: 120px;">
    <template #body="slotProps">
      <Image :src="concatenarImagen(slotProps.data.Imagen)"  alt="Imagen de evidencia"
      width="100"
      preview
      class="preview-image"
      @click="showFullImage(slotProps.data.Imagen)"/>
    </template>
  </Column>
</DataTable>

<h5 class="highlight-title3">Existencia de cuentas predeterminadas o genéricas</h5>
<DataTable :value="productsTipo4" tableStyle="min-width: 650px">
  <Column field="Observaciones" header="Observaciones"></Column>
  <Column field="Imagen" header="Imagen" style="width: 120px;">
    <template #body="slotProps">
      <Image :src="concatenarImagen(slotProps.data.Imagen)" alt="Imagen de evidencia"
      width="100"
       preview
       class="preview-image"
       @click="showFullImage(slotProps.data.Imagen)"/>
    </template>
  </Column>
</DataTable>

<h5 class="highlight-title4">Servicio institucional de Internet</h5>
<DataTable :value="productsTipo5" tableStyle="min-width: 650px">
  <Column field="Observaciones" header="Observaciones"></Column>
  <Column field="Imagen" header="Imagen" style="width: 120px;">
    <template #body="slotProps">
      <Image :src="concatenarImagen(slotProps.data.Imagen)" alt="Imagen de evidencia"
      width="100"
      preview
      class="preview-image"
       @click="showFullImage(slotProps.data.Imagen)"/>
    </template>
  </Column>
</DataTable>



        </div>
      </div>
    </div>
    </div>
    <!-- Botón de Cancelar -->
    <template #footer>
    <div class="custom-footer">
        <Button
            label="Cerrar"
            icon="pi pi-times"
            class="p-button-text p-button-sm  close-button"
            @click="cerrarEvidencia"
            
        />
    </div>
</template>
  </Dialog>
  </div>
</template>

<script>
import Srvr from "../service/Inventario";
import SrvrPerifericos from "../service/Perifericos";
import SrvrEquipos from "../service/EquiposComputo";
import { FilterMatchMode } from "primevue/api";
import Utilerias from "../utilidades/Utilerias";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      evidenciaData: [], // Almacena todas las evidencias recibidas
    productsTipo1: [], // Equipos ingresados a Dominio
    productsTipo2: [], // Protección Antivirus y Antimalware
    productsTipo3: [], // Parches de seguridad del antivirus
    productsTipo4: [], // Existencia de cuentas predeterminadas o genéricas
    productsTipo5: [], // Servicio institucional de Internet
      lstUnidades: [],
      selectedUnidadFiltro: null,
      lstEquipos: null,
      lstPerifericos: null,
      imageUrl: null,
      fileName: "",
      periferico: {},
      lstTipos: [
        {
          Tipo: "COMPUTADORA",
        },
        {
          Tipo: "LAPTOP",
        },
        {
          Tipo: "MULTIFUNCIONAL",
        },
        {
          Tipo: "SERVIDOR",
        },
        {
          Tipo: "PROVEEDOR",
        },
        {
          Tipo: "IMPRESORA",
        },
        {
          Tipo: "PANTALLA",
        },
        {
          Tipo: "LECTOR DE BARRAS",
        },
        {
          Tipo: "SCANNER",
        },
        {
          Tipo: "DIADEMA",
        },
        {
          Tipo: "CAMARA WEB",
        },
        {
          Tipo: "UPS",
        },
      ],
      lstTiposPerifericos: [
        {
          Tipo: "IMPRESORA",
        },
        {
          Tipo: "MULTIFUNCIONAL",
        },
        {
          Tipo: "MONITOR",
        },
        {
          Tipo: "LECTOR",
        },
        {
          Tipo: "PANTALLA",
        },
        {
          Tipo: "DIADEMA",
        },
        {
          Tipo: "CAMARA WEB",
        },
        {
          Tipo: "ESCANER",
        },
        {
          Tipo: "UPS",
        },
      ],
      lstModalidades: null, //['N/A','CONFIGURABLE','PLANO','SERVICIOS'],
      filtersSegmentados: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      filtersNoSegmentados: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      filtersPerifericos1: null,
      filtersPerifericos2: null,
      filter: null,
      loading: true,
      loadingPerifericos: false,
      loadingEquipos: false,
      loadingEquiposNoSegmentados: false,
      loadingTab1: false,
      loadingTab2: false,
      submitted: false,
      showAgregar: false,
      showAgregarPeriferico: false,
      dialogVisible: false,
      dialogEvidenciasVisible: false,
      showNuevaVerificacion: false,
      equipoEdited: null,
      modoEdicion: "",
      expandedRows: [],
      expandedRowsPerifericosSegmentados: [],
      expandedRowsPerifericosNoSegmentados: [],
      expandedRowsNoSegmentados: [],
      expandedRowsSegmentados: [],
      expandedRowsEvidencia: [],
      DatosOCS: [],
      equipo: {},
      verModelo: false,
      activeTabIndex: 0,
      equipoIndex: 0,
      NoSegmentado: false,
      dropdownDisabled: false,
      evidencia: {
        IP_equipo: "",
        Matricula_realizo: "",
        Nombres: '',
        URL_imagen: "",
        Observaciones: "",
        Fecha: '',
        Referencia_red: "",  
        Area: "",            
        Usuario: "",
        Unidad: '',  
        Id_lista_verificacion: null,    
      },
      activeAccordionIndex1: 1,
      activeAccordionIndex2: 2,
      activeAccordionIndex3: 3,
      activeAccordionIndex4: 4,
      activeAccordionIndex5: 5,
      fileUploadsAccordion1: [{ imageUrl: null, Observaciones: '', fileName: '' }],
      fileUploadsAccordion2: [{ imageUrl: null, Observaciones: '', fileName: '' }],
      fileUploadsAccordion3: [{ imageUrl: null, Observaciones: '', fileName: '' }],
      fileUploadsAccordion4: [{ imageUrl: null, Observaciones: '', fileName: '' }],
      fileUploadsAccordion5: [{ imageUrl: null, Observaciones: '', fileName: '' }],
      showDialog: false,
      showGallery: false,
      selectedEquipo: null,
      tableEvidencia: [],
      evidenciaTableData: [],
      galleryImages: [],
      responsiveOptions: [
        {
          breakpoint: '1300px',
          numVisible: 4
        },
        {
          breakpoint: '575px',
          numVisible: 1
        }
      ],
      equipoIP: null,
      activeIndexEvidencia: 0,
      displayImagenesEvidencia: false,
      customDisplay: false,
      //idEquiposAbiertos: [],
    };
  },
  created() {
  },
  mounted() {
    this.loadUserData();
    var t = this;
    t.cargaInicial();
  },
  methods: {
    concatenarImagen(urlImagen){
      if(urlImagen != "")
          return this.getUrlServicios + urlImagen.replace("~/","");
      else
          return "../assets/sinImagen.png";
    },
    nuevaVerificacion() {
      this.showNuevaVerificacion = true;
    },
    forzarUpdate() {
      this.$forceUpdate();
    },
    onRowExpand(event) {
      this.cargaPerifericos(event.data);
    },
    rowClass(data) {
      const index = this.lstEquipos.indexOf(data);
      const lastIndex = this.lstEquipos.length - 1;
      const filasSatelites = 126;
      const ultimasFilasSatelites = 119;
      const filasTotales = 254;
      const ultimasFilasTotales = 14;
      const primerasFilasApartadas = 10;

      if (index < primerasFilasApartadas) {
        return "filas-reservadas";
      }
      if (
        this.lstEquipos.length == filasSatelites &&
        index >= ultimasFilasSatelites &&
        index <= filasSatelites
      ) {
        return "filas-reservadas";
      }
      if (
        this.lstEquipos.length == filasTotales &&
        index >= lastIndex - ultimasFilasTotales
      ) {
        return "filas-reservadas";
      }
      return "";
    },
    cambioTap(event) {
      this.activeTabIndex = event.index;
      if (this.selectedUnidadFiltro != null) {
        if (event.index == 0) {
          this.cargaEquiposPorUnidad();
        }
        if (event.index == 1) {
          this.cargaEquiposNoSegmentados();
        }
      }
    },
    shouldShowButton(data) {
      return !data.DatosOCS || (data.DatosOCS && !this.equiposOCS(data));
    },
    mostrarPerifericos(data) {
      return !(data.DatosOCS && this.equiposOCS(data));
    },
    equiposOCS(data) {
      return [
        "BIOMETRICO",
        "BIOMÉTRICO",
        "PROVEEDOR",
        "SERVIDOR",
        "CÁMARA",
        "CÁMARAS",
        "CONMUTADOR",
        "TELÉFONO IP",
        "DVR",
        "INALÁMBRICO",
        "INALAMBRICO",
        "ROUTER",
        "SWITCH",
      ].includes(data.DatosOCS.TIPO);
    },
    validarEstructuraIP(ip) {
      const ipRegex = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;
      return ipRegex.test(ip);
    },
    escribeIP(obj) {
      return obj.IP;
    },
    getFechaWCF(fecha, hora) {
      var utils = new Utilerias();
      return utils.getFechaWCF(fecha, hora);
    },
    getFechaWCFDate(fecha, hora) {
      var utils = new Utilerias();
      return utils.getFechaWCFDate(fecha, hora);
    },
    formateaFechaDATE(fecha) {
      return "/Date(" + fecha.getTime() + ")/";
    },
    cancelarDialogo() {
      this.submitted = false;
      this.showAgregar = false;
      this.showAgregarPeriferico = false;
      this.dialogVisible = false;
      this.showGallery = false;
      this.imageUrl = null;
      this.modoEdicion = "";
      this.equipo = {};
      this.periferico = {};
      this.NoSegmentado = false;
      //this.reiniciaEquipo();
      this.showNuevaVerificacion = false;
      this.resetFormularioEvidencia();
    },
    cancelarDialogoTable(){
      this.showDialog = false;
    },
    cancelarverificacion(){
      this.showNuevaVerificacion = false;
      this.resetAcordeonesYFileUploads();
      this.limpiarCamposEvidencia();
     
    },
    cargaInicial() {
      var t = this;
      var ctlSvr = new Srvr();
      ctlSvr.getUnidades(t).then((res) => {
        //console.log(res);
        t.lstUnidades = res;
      });
    },
    cargaEquipos() {
      var t = this;
      if (t.activeTabIndex == 0) {
        this.cargaEquiposPorUnidad();
      }
      if (t.activeTabIndex == 1) {
        this.cargaEquiposNoSegmentados();
      }
    },
    cargaEquiposPorUnidad() {
      var t = this;
      var ctlSvr = new SrvrEquipos();
      t.loadingEquipos = true;
      t.loadingTab2 = true;
      this.expandedRowsSegmentados = null;
      t.lstEquipos = [];
      ctlSvr.getEquiposComputo(t, t.selectedUnidadFiltro.SUBRED, true).then((res) => {
        t.loadingEquipos = false;
        t.loadingTab2 = false;
        t.lstEquipos = res;
       
        // Extraer unidades, áreas y usuarios a partir de los equipos y la unidad seleccionada
        const unidadesConAreasYUsuarios = this.extraerUnidades(res, t.selectedUnidadFiltro.UNIDAD);
        console.log("Unidades, áreas y usuarios extraídos:", unidadesConAreasYUsuarios);

      });
    },
    cargaEquiposNoSegmentados() {
      var t = this;
      var ctlSvr = new SrvrEquipos();
      t.loadingEquiposNoSegmentados = true;
      t.loadingTab1 = true;
      this.expandedRowsNoSegmentados = null;
      t.lstEquipos = [];
      ctlSvr
        .getEquiposPorUnidadSinSubred(t, t.selectedUnidadFiltro.UNIDAD)
        .then((res) => {
          t.loadingEquiposNoSegmentados = false;
          t.loadingTab1 = false;
          t.lstEquipos = res;
        });
       
    },
    extraerUnidades(equipos) {
    const unidadesConAreasYUsuarios = equipos.map(equipo => {
        return {
            unidad: equipo.Unidad || 'Unidad no disponible',
            area: equipo.Area || 'Área no disponible',
            usuario: equipo.Usuario || 'Usuario no disponible'
        };
    });
    return unidadesConAreasYUsuarios;
    },    
    cargaPerifericos(obj) {
      var t = this;
      var ctlSvr = new SrvrPerifericos();
      t.loadingPerifericos = true;
      if (obj.Id_equipo_computo === 0) {
        obj.lstPerifericos = [];
        t.loadingPerifericos = false;
      } else {
        ctlSvr.getPerifericosPorEquipo(t, obj.Id_equipo_computo).then((res) => {
          t.loadingPerifericos = false;
          obj.lstPerifericos = res;
        });
      }
    },
    agregarEquipo() {
      this.cargaInicial();
      this.submitted = false;
      this.showAgregar = true;
      this.modoEdicion = "Agregar";
      //console.log(this.equipo);
      if (this.equipo.DatosOCS) {
        this.equipo.Usuario = this.equipo.DatosOCS.USERID;
        this.equipo.Nombre_equipo = this.equipo.DatosOCS.NOMBRE;
        this.equipo.Ubicacion = this.equipo.DatosOCS.DESCRIPTION;
        this.equipo.tTipo = { Tipo: this.equipo.DatosOCS.TIPO };
        this.equipo.Area = this.equipo.DatosOCS.DESCRIPTION;
        this.equipo.MAC = this.equipo.DatosOCS.MAC;
        this.equipo.SO = this.equipo.DatosOCS.OSNAME;
        this.equipo.Modelo = this.equipo.DatosOCS.SMODEL;
        this.equipo.Marca = this.equipo.DatosOCS.BMANUFACTURER;
        this.equipo.Serie = this.equipo.DatosOCS.SSN;
        this.equipo.Descripcion = this.equipo.DatosOCS.DESCRIPTION;
      }
      if (this.equipo.IP === undefined) {
        this.equipo.IP = this.selectedUnidadFiltro.SUBRED;
      }
      this.equipo.tUnidad = this.selectedUnidadFiltro;
      this.equipo.IP = this.escribeIP(this.equipo);
    },
    agregarPeriferico(objEquipo) {
      this.cargaInicial();
      this.submitted = false;
      this.showAgregarPeriferico = true;
      this.modoEdicion = "Agregar";
      this.periferico.Id_equipo_computo = objEquipo.Id_equipo_computo;
      this.periferico.tUnidad = {};
      Object.assign(this.periferico.tUnidad, this.selectedUnidadFiltro);
    },
    editarEquipo(obj) {
      this.equipo = { ...obj };
      this.showAgregar = true;
      //console.log(this.equipo);
      if (this.equipo.Id_equipo_computo == 0) {
        this.agregarEquipo();
      } else {
        this.modoEdicion = "Editar";
        this.equipo.tUnidad = {};
        let unidad = {
          UNIDAD: this.equipo.Unidad,
          SUBRED: this.equipo.Subred,
          UNIDAD_SUBRED: this.equipo.Unidad + " (" + this.equipo.Subred + ")",
        };
        this.equipo.tUnidad = unidad;
        this.equipo.Id_usuario_mod = this.getUsuarioLogueado.Usuario.Id_usuario;
        this.equipo.tTipo = {};
        this.equipo.tTipo = { Tipo: this.equipo.Tipo };
      }
    },
    editarEquipoNoSegmentado(obj) {
      this.equipo = { ...obj };
      this.showAgregar = true;
      this.modoEdicion = "Editar";
      this.NoSegmentado = true;
      // console.log(this.equipo);
      this.equipo.tUnidad = {};
      let unidad = {
        UNIDAD: this.equipo.Unidad,
        SUBRED: null,
        UNIDAD_SUBRED: this.equipo.Unidad + " (" + null + ")",
      };
      this.equipo.tUnidad = unidad;

      this.equipo.Id_usuario_mod = this.getUsuarioLogueado.Usuario.Id_usuario;
      this.equipo.tTipo = {};
      this.equipo.tTipo = { Tipo: this.equipo.Tipo };
    },
    editarPeriferico(obj) {
      this.periferico = { ...obj };
      this.showAgregarPeriferico = true;
      this.modoEdicion = "Editar";
      this.periferico.tUnidad = {};
      let unidad = {
        UNIDAD: this.periferico.Unidad,
        SUBRED: this.periferico.Subred,
        UNIDAD_SUBRED:
          this.periferico.Unidad + " (" + this.periferico.Subred + ")",
      };
      this.periferico.tUnidad = unidad;
      this.periferico.Id_usuario_mod =
        this.getUsuarioLogueado.Usuario.Id_usuario;
      this.periferico.tTipo = {};
      this.periferico.tTipo = { Tipo: this.periferico.Tipo };
      this.periferico.Fecha_instalacion = this.getFechaWCFDate(
        this.periferico.Fecha_instalacion,
        false
      );
      //this.reiniciaEquipo();
    },
    borrarEquipo(obj) {
      var t = this;
      let id_usuario = t.getUsuarioLogueado.Usuario.Id_usuario;
      var ok = confirm("¿Quiere eliminar este equipo?");
      if (ok) {
        var val = obj.Id_equipo_computo;
        var ctlSvr = new SrvrEquipos();
        ctlSvr.deleteEquipoComputo(t, val, id_usuario).then(() => {
          t.$toast.add({
            severity: "success",
            summary: "AVISO",
            detail: "Equipo eliminado correctamente",
            life: 3000,
          });
          t.cargaEquiposPorUnidad();
        });
      }
    },
    borrarEquipoNoSegmentado(obj) {
      var t = this;
      let id_usuario = t.getUsuarioLogueado.Usuario.Id_usuario;
      var ok = confirm("¿Quiere eliminar este equipo?");
      if (ok) {
        var val = obj.Id_equipo_computo;
        var ctlSvr = new SrvrEquipos();
        ctlSvr.deleteEquipoComputo(t, val, id_usuario).then(() => {
          t.$toast.add({
            severity: "success",
            summary: "AVISO",
            detail: "Equipo eliminado correctamente",
            life: 3000,
          });
          t.cargaEquiposNoSegmentados();
        });
      }
    },
    eliminarPeriferico(obj) {
      var t = this;
      var ok = confirm("¿Quiere eliminar este dispositivo?");
      //console.log(obj);
      if (ok) {
        let id_usuario = t.getUsuarioLogueado.Usuario.Id_usuario;
        var val = obj.Id_equipo_periferico;
        //this.periferico.Id_equipo_computo = this.idEquiposAbiertos.Id_equipo_computo;
        var ctlSvr = new SrvrPerifericos();
        ctlSvr.deletePeriferico(t, val, id_usuario).then(() => {
          t.$toast.add({
            severity: "success",
            summary: "AVISO",
            detail: "Dispositivo eliminado correctamente",
            life: 3000,
          });
          let equipo = t.lstEquipos.find(
            (e) => e.Id_equipo_computo == obj.Id_equipo_computo
          );
          t.cargaPerifericos(equipo);
          if (equipo) {
            equipo.num_perifericos--;
          }
        });
      }
    },
    limpiarCamposEvidencia(){
      this.evidencia.Referencia_red = "";
    },
    guardarPeriferico() {
      var t = this;
      this.submitted = true;
      //t.periferico.Id_equipo_computo = t.idEquiposAbiertos.Id_equipo_computo;
      if (
        !t.periferico ||
        !t.periferico.tUnidad ||
        !t.periferico.tTipo ||
        !t.periferico.Marca ||
        !t.periferico.Modelo
      )
        return;

      //console.log(t.equipo);

      t.periferico.Unidad = t.periferico.tUnidad.UNIDAD;
      t.periferico.Subred = t.periferico.tUnidad.SUBRED;
      const fechaOriginal = t.periferico.Fecha_instalacion;
      const restoreFechaOriginal = () => {
        t.periferico.Fecha_instalacion = fechaOriginal;
      };

      if (t.periferico.tTipo.Tipo) {
        t.periferico.Tipo = t.periferico.tTipo.Tipo;
      } else {
        t.periferico.Tipo = t.periferico.tTipo;
      }

      if (!t.periferico.NNI) {
        t.periferico.NNI = "";
      }

      if (!t.equipo.MAC) {
        t.equipo.MAC = "";
      }

      if (!t.periferico.Serie) {
        t.periferico.Serie = "";
      }

      if (!t.periferico.Observaciones) {
        t.periferico.Observaciones = "";
      }

      if (!t.periferico.IP) {
        t.periferico.IP = null;
        t.periferico.Subred = null;
      }

      t.periferico.Fecha_instalacion = this.formateaFechaDATE(
        t.periferico.Fecha_instalacion
      );

      t.periferico.Id_usuario_registro =
        t.getUsuarioLogueado.Usuario.Id_usuario;

      if (t.periferico.IP !== null) {
        if (!t.validarEstructuraIP(t.periferico.IP)) {
          t.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "La IP ingresada no tiene una estructura válida.",
            life: 5000,
          });
          restoreFechaOriginal();
          return;
        }
      }
      var ctlSvr = new SrvrPerifericos();

      if (t.modoEdicion == "Agregar") {
        ctlSvr
          .addPeriferico(t, t.periferico)
          .then(() => {
            //console.log(res);
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Periférico agregado correctamente",
              life: 3000,
            });
            let equipo = t.lstEquipos.find(
              (e) => e.Id_equipo_computo == t.periferico.Id_equipo_computo
            );
            if (equipo) t.cargaPerifericos(equipo);
            equipo.num_perifericos++;
            t.cancelarDialogo();
          })
          .catch(() => {
            restoreFechaOriginal();
          });
      } else {
        ctlSvr
          .updatePeriferico(t, t.periferico)
          .then(() => {
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Periférico editado correctamente",
              life: 3000,
            });
            let equipo = t.lstEquipos.find(
              (e) => e.Id_equipo_computo == t.periferico.Id_equipo_computo
            );
            if (equipo) t.cargaPerifericos(equipo);
            t.cancelarDialogo();
          })
          .catch(() => {
            restoreFechaOriginal();
          });
      }
    },
    guardarEquipo() {
      var t = this;
      this.submitted = true;

      if (this.NoSegmentado == false) {
        if (
          !t.equipo ||
          !t.equipo.tUnidad ||
          !t.equipo.tTipo ||
          !t.equipo.Marca ||
          !t.equipo.Modelo ||
          !t.equipo.IP
        ) {
          return;
        }
        //console.log(t.equipo);

        t.equipo.Unidad = t.equipo.tUnidad.UNIDAD;
        t.equipo.Subred = t.equipo.tUnidad.SUBRED;

        if (t.equipo.tTipo.Tipo) {
          t.equipo.Tipo = t.equipo.tTipo.Tipo;
        } else {
          t.equipo.Tipo = t.equipo.tTipo;
        }

        if (!t.equipo.NNI) {
          t.equipo.NNI = "";
        }

        if (!t.equipo.MAC) {
          t.equipo.MAC = "";
        }

        if (!t.equipo.Usuario) {
          t.equipo.Usuario = "";
        }

        if (!t.equipo.Nombre_equipo) {
          t.equipo.Nombre_equipo = "";
        }

        if (!t.equipo.Serie) {
          t.equipo.Serie = "";
        }

        if (!t.equipo.Ubicacion) {
          t.equipo.Ubicacion = "";
        }

        if (!t.equipo.Area) {
          t.equipo.Area = "";
        }

        if (!t.equipo.SO) {
          t.equipo.SO = "";
        }

        if (!t.equipo.Descripcion) {
          t.equipo.Descripcion = "";
        }

        if (!t.equipo.Observaciones) {
          t.equipo.Observaciones = "";
        }

        t.equipo.Id_usuario_registro = t.getUsuarioLogueado.Usuario.Id_usuario;

        if (!t.validarEstructuraIP(t.equipo.IP)) {
          t.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "La IP ingresada no tiene una estructura válida.",
            life: 5000,
          });
          return;
        }
        var ctlSvr = new SrvrEquipos();
        if (t.modoEdicion == "Agregar") {
          ctlSvr.addEquipoComputo(t, t.equipo).then(() => {
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Equipo agregado correctamente",
              life: 3000,
            });
            t.cancelarDialogo();
            t.cargaEquiposPorUnidad();
          });
        } else {
          ctlSvr.updateEquipoComputo(t, t.equipo).then(() => {
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Equipo editado correctamente",
              life: 3000,
            });
            t.cancelarDialogo();
            t.cargaEquiposPorUnidad();
          });
        }
      } else {
        if (
          !t.equipo ||
          !t.equipo.tUnidad ||
          !t.equipo.tTipo ||
          !t.equipo.Ubicacion ||
          !t.equipo.Marca ||
          !t.equipo.Modelo
        ) {
          return;
        }
        t.equipo.Unidad = t.equipo.tUnidad.UNIDAD;
        t.equipo.Subred = null;
        t.equipo.IP = null;

        if (t.equipo.tTipo.Tipo) {
          t.equipo.Tipo = t.equipo.tTipo.Tipo;
        } else {
          t.equipo.Tipo = t.equipo.tTipo;
        }

        if (!t.equipo.NNI) {
          t.equipo.NNI = "";
        }

        if (!t.equipo.MAC) {
          t.equipo.MAC = "";
        }

        if (!t.equipo.Observaciones) {
          t.equipo.Observaciones = "";
        }

        if (!t.equipo.Usuario) {
          t.equipo.Usuario = "";
        }

        if (!t.equipo.Nombre_equipo) {
          t.equipo.Nombre_equipo = "";
        }

        if (!t.equipo.Serie) {
          t.equipo.Serie = "";
        }

        if (!t.equipo.Ubicacion) {
          t.equipo.Ubicacion = "";
        }

        if (!t.equipo.Area) {
          t.equipo.Area = "";
        }

        if (!t.equipo.SO) {
          t.equipo.SO = "";
        }

        if (!t.equipo.Descripcion) {
          t.equipo.Descripcion = "";
        }

        if (!t.equipo.Observaciones) {
          t.equipo.Observaciones = "";
        }

        t.equipo.Id_usuario_registro = t.getUsuarioLogueado.Usuario.Id_usuario;

        var ctlSvr2 = new SrvrEquipos();
        if (t.modoEdicion == "Agregar") {
          ctlSvr2.addEquipoComputo(t, t.equipo).then(() => {
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Equipo agregado correctamente",
              life: 3000,
            });
            t.cancelarDialogo();
            t.cargaEquiposNoSegmentados();
          });
        } else {
          ctlSvr2.updateEquipoComputo(t, t.equipo).then(() => {
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Equipo editado correctamente",
              life: 3000,
            });
            t.cancelarDialogo();
            t.cargaEquiposNoSegmentados();
          });
        }
      }
    },
    listaVerificacion() {
      this.dialogVisible = true;
      this.resetFormularioEvidencia();
    },
    resetFormularioEvidencia(){
      this.evidencia = {
        IP_equipo: "",
        Matricula_realizo: "",
        Nombres: "",
        Apellidos: "",
        Tipo_evidencia: "",
        URL_imagen: "",
        Observaciones: "",
      }
    },
   
    clearTableData() {
      this.tableEvidencia = [];
    },
    agregarEvidencia() {
  var t = this;
  this.submitted = true;

  // Validación de los campos obligatorios
  if (!t.evidencia.Matricula_realizo || !t.evidencia.Fecha || !t.evidencia.Referencia_red || !t.evidencia.Unidad || !t.evidencia.Area || !t.evidencia.Usuario) {
    t.$toast.add({
      severity: "error",
      summary: "Error",
      detail: "Todos los campos son obligatorios.",
      life: 3000
    });
    return;
  }

  // Verificar si se ha seleccionado al menos un archivo en cada acordeón
  const archivoAccordion1 = this.fileUploadsAccordion1.some(item => item.imageUrl);
  const archivoAccordion2 = this.fileUploadsAccordion2.some(item => item.imageUrl);
  const archivoAccordion3 = this.fileUploadsAccordion3.some(item => item.imageUrl);
  const archivoAccordion4 = this.fileUploadsAccordion4.some(item => item.imageUrl);
  const archivoAccordion5 = this.fileUploadsAccordion5.some(item => item.imageUrl);

  if (!archivoAccordion1 || !archivoAccordion2 || !archivoAccordion3 || !archivoAccordion4 || !archivoAccordion5) {
    t.$toast.add({
      severity: "error",
      summary: "Error",
      detail: "Debe seleccionar al menos un archivo en cada control de revisión.",
      life: 3000
    });
    return;
  }

    // Convertir la fecha a formato WCF
    function toWCFDateFormat(date) {
        return "/Date(" + date.getTime() + ")/";
    }
    let now = new Date();
    let timestamp = toWCFDateFormat(now);

    // Objeto de datos principales
    let objEquiposListaVerificacion = {
        Id_equipo_computo: t.selectedEquipo,
        IP_equipo: t.evidencia.IP_equipo || "",
        Fecha: timestamp,
        Id_usuario_realizo: t.getUsuarioLogueado.Usuario.Id_usuario,
        Matricula_realizo: t.evidencia.Matricula_realizo || "",
        Nombres: t.evidencia.Nombres || "",
        Referencia_red: t.evidencia.Referencia_red || "",
        Unidad: t.evidencia.Unidad || "",
        Area: t.evidencia.Area || "",
        Usuario: t.evidencia.Usuario || "",
        Evidencias: []
    };

    this.tableEvidencia.push(objEquiposListaVerificacion);

    let evidencias = [];

    // Función para manejar los archivos del acordeón
    function processFiles(accordionFiles, tipoEvidencia) {
        accordionFiles.forEach((fileItem, index) => {
            if (fileItem.imageUrl) { // Asegúrate de que hay una imagen subida
                let file = t.$refs['fileUploadRef' + tipoEvidencia + index].files[0]; // Obtener el archivo del FileUpload

                let reader = new FileReader();
                reader.readAsArrayBuffer(file);
                reader.onloadend = function (evt) {
                    if (evt.target.readyState === FileReader.DONE) {
                        var arrayBuffer = evt.target.result,
                            array = new Uint8Array(arrayBuffer);
                        var fileByteArray = [];
                        for (var j = 0; j < array.length; j++) {
                            fileByteArray.push(array[j]);
                        }

                        let newFileName = file.name.replace(" ", "").replace("_", "");

                        // Crear objeto de evidencia para cada archivo del acordeón
                        let objEvidencia = {
                            Id_equipo_computo: t.selectedEquipo,
                            Tipo_evidencia: tipoEvidencia,
                            URL_imagen: fileItem.imageUrl || "",
                            Fecha_carga: timestamp,
                            Observaciones: fileItem.Observaciones || "",
                            ImagenEvidencia: {
                                fileName: newFileName,
                                fileByte: fileByteArray,
                            }
                        };

                        evidencias.push(objEvidencia);

                        // Verificar si se está agregando correctamente al array de evidencias
                        console.log("Evidencias hasta ahora (con acordeón):", evidencias);

                        // Enviar la solicitud una vez que todos los archivos se hayan procesado
                        if (evidencias.length ===
                            t.fileUploadsAccordion1.length +
                            t.fileUploadsAccordion2.length +
                            t.fileUploadsAccordion3.length +
                            t.fileUploadsAccordion4.length +
                            t.fileUploadsAccordion5.length) {
                            let obj = {
                                EquiposListaVerificacion: objEquiposListaVerificacion,
                                Evidencias: evidencias,
                            };
                            console.log("Enviando solicitud con el siguiente objeto (con acordeón):", obj);
                            t.sendRequest(t, obj);
                        }
                    }
                };
            }
        });
    }

    // Procesar archivos del primer acordeón
    if (t.fileUploadsAccordion1.length > 0) {
        processFiles(t.fileUploadsAccordion1, "1");
    }

    // Procesar archivos del segundo acordeón
    if (t.fileUploadsAccordion2.length > 0) {
        processFiles(t.fileUploadsAccordion2, "2");
    }

    // Procesar archivos del tercer acordeón
    if (t.fileUploadsAccordion3.length > 0) {
        processFiles(t.fileUploadsAccordion3, "3");
    }

    // Procesar archivos del cuarto acordeón
    if (t.fileUploadsAccordion4.length > 0) {
        processFiles(t.fileUploadsAccordion4, "4");
    }

    // Procesar archivos del quinto acordeón
    if (t.fileUploadsAccordion5.length > 0) {
        processFiles(t.fileUploadsAccordion5, "5");
    }

    // Enviar la solicitud sin evidencias si no hay archivos
    if (t.fileUploadsAccordion1.length === 0 &&
        t.fileUploadsAccordion2.length === 0 &&
        t.fileUploadsAccordion3.length === 0 &&
        t.fileUploadsAccordion4.length === 0 &&
        t.fileUploadsAccordion5.length === 0) {
        console.log("No se encontraron archivos en el acordeón, enviando solicitud sin archivos.");
        let obj = {
            EquiposListaVerificacion: objEquiposListaVerificacion,
            Evidencias: evidencias, // Vacío pero se enviará
        };
        console.log("Enviando objeto sin archivos:", obj);
        t.sendRequest(t, obj);
    }
  },


sendRequest(t, obj) {
  var srvrEquipos = new SrvrEquipos();
  srvrEquipos
    .addEvidencia(t, obj)
    .then((response) => {
      try {
        const data = response;
        if (data && data.ok) {
          t.$toast.add({
            severity: "success",
            summary: "AVISO",
            detail: "Evidencia agregada correctamente",
            life: 3000,
          });
          this.showNuevaVerificacion = false;
          this.resetAcordeonesYFileUploads();
          this.limpiarCamposEvidencia();
          this.selectIP({ Id_equipo_computo: this.selectedEquipo});
          //t.getEquipoVerificacion(t.selectedEquipo);
        } else {
          t.$toast.add({
            severity: "warn",
            summary: "AVISO",
            detail: "Error al procesar la respuesta del servidor",
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Error al analizar la respuesta del servidor:", error);
        t.$toast.add({
          severity: "error",
          summary: "ERROR",
          detail: "Error al agregar la evidencia",
          life: 3000,
        });
      }
    })
    .catch((error) => {
      console.error("Error al agregar la evidencia:", error);
      t.$toast.add({
        severity: "error",
        summary: "ERROR",
        detail: "Error al agregar la evidencia",
        life: 3000,
      });
    });
},

    tableVerificacion(objEquipo) {
      this.selectedEquipo = objEquipo.Id_equipo_computo;
      this.showDialog = true;
      this.getEquipoVerificacion(this.selectedEquipo);
       console.log("Id equipo computo", this.selectedEquipo);
    },
    selectIP(equipo) {
  this.evidencia.IP_equipo = equipo.IP;
  this.selectedEquipo = equipo.Id_equipo_computo;
  this.dialogVisible = true;
 
  // Inicializar la tabla de evidencia como vacía al abrir el diálogo
  this.tableEvidencia = [];

  let t = this;
  let srv = new SrvrEquipos();

  // Método para cargar las listas de verificación
  srv.getEquipoVerificacion(t, equipo.Id_equipo_computo).then(res => {
    if (res && res.length > 0) {
      t.tableEvidencia = res; // Cargar los registros si hay datos
    } else {
      // Mostrar un mensaje o indicar que no hay datos
      t.tableEvidencia = []; // Asegurar que esté vacío
      t.noDataMessage = "No hay registros de verificación para este equipo."; // Puedes usar esto en tu template
    }
  }).catch(error => {
    console.error("Error al obtener la verificación del equipo:", error);
    t.noDataMessage = "Error al cargar los datos.";
  });

  this.evidencia.Unidad = equipo.Unidad || equipo.unidad || 'Unidad no disponible';
  this.evidencia.Area = equipo.Area || equipo.area || 'Área no disponible';
  this.evidencia.Usuario = equipo.Usuario || equipo.usuario || equipo.Nombres || 'Usuario no disponible';

  // Verificar qué datos tiene el objeto equipo
  console.log("Datos completos del equipo seleccionado:", equipo);
  console.log("Datos extraídos del equipo seleccionado:", this.evidencia);
},

    setCurrentDate() {
      const today = new Date();
      const anio = today.getFullYear();
      const mes = (today.getMonth() + 1).toString().padStart(2, '0');
      const dia = today.getDate().toString().padStart(2, '0');
      // Fecha en formato YYYY-MM-DD
      this.evidencia.Fecha = `${anio}-${mes}-${dia}`;
    },
    filterEvidenciasByFecha(evidencias, fecha) {
      if (!Array.isArray(evidencias)) {
        return [];
      }
      let parsedFecha = this.getFechaWCF(fecha, true);
      const filteredEvidencias = evidencias.filter(evidencia => {
        let parsedFechaCarga = this.getFechaWCF(evidencia.Fecha_carga, true);
        return parsedFecha === parsedFechaCarga;
      });
      const uniqueEvidencias = [];
      const tipoEvidencias = new Set();
      filteredEvidencias.forEach(evidencia => {
        if (evidencia.Tipo_evidencia && !tipoEvidencias.has(evidencia.Tipo_evidencia)) {
          tipoEvidencias.add(evidencia.Tipo_evidencia);
          uniqueEvidencias.push(evidencia);
        }
      });
      return uniqueEvidencias;
    },
    closeGallery(){
      this.displayImagenesEvidencia = false;
    },
    onRowSelect(event) {
      this.selectedEquipo = event.value;
      this.openDialog();
    },
    openDialog() {
      if (this.selectedEquipo) {
        this.evidencia.IP_equipo = this.selectedEquipo.IP;
        this.autofillMatricula();
        this.dialogVisible = true;
      }
    },
    mostrarNuevaVerificacion() {
      this.showNuevaVerificacion = true;
      this.autofillMatricula();
      this.setCurrentDate();
    },
    mostrarDialogEvidencias(id_lista_verificacion) {
      if (!id_lista_verificacion) {
        console.log("ID de la lista de verificación no disponible");
        return;
      }

  let t = this;
  let srv = new SrvrEquipos();
 
  srv.getEvidenciasByListaVerificacion(t, id_lista_verificacion)
    .then(function(res) {
      // Guardar las evidencias obtenidas en la variable de estado
      t.evidenciaData = res;  // Guardar todas las evidencias

      // Filtrar y asignar datos por Tipo_evidencia
      t.productsTipo1 = t.evidenciaData.filter(e => e.Tipo_evidencia === "1").map(e => ({
        Observaciones: e.Observaciones,
        Imagen: e.URL_imagen
      }));
      t.productsTipo2 = t.evidenciaData.filter(e => e.Tipo_evidencia === "2").map(e => ({
        Observaciones: e.Observaciones,
        Imagen: e.URL_imagen
      }));
      t.productsTipo3 = t.evidenciaData.filter(e => e.Tipo_evidencia === "3").map(e => ({
        Observaciones: e.Observaciones,
        Imagen: e.URL_imagen
      }));
      t.productsTipo4 = t.evidenciaData.filter(e => e.Tipo_evidencia === "4").map(e => ({
        Observaciones: e.Observaciones,
        Imagen: e.URL_imagen
      }));
      t.productsTipo5 = t.evidenciaData.filter(e => e.Tipo_evidencia === "5").map(e => ({
        Observaciones: e.Observaciones,
        Imagen: e.URL_imagen
      }));

      // Seleccionar una evidencia específica, por ejemplo, la primera
      if (t.evidenciaData.length > 0) {
        const evidenciaSeleccionada = t.evidenciaData[0];
       
        // Asignar los valores de la evidencia a los campos del formulario
        t.evidencia = {...t.evidencia,
          Unidad: evidenciaSeleccionada.Unidad, // Asigna el valor que corresponda
          Area: evidenciaSeleccionada.Area,
          Usuario: evidenciaSeleccionada.Usuario,
          Referencia_red: evidenciaSeleccionada.Referencia_Red,
          
        };
              
        // Convertir `Fecha_carga` usando `getFechaWCFDate`, luego formatearla a `dd/mm/yyyy hh:mm`
        const fechaConvertida = t.getFechaWCFDate(evidenciaSeleccionada.Fecha_carga, true);
        const dia = fechaConvertida.getDate().toString().padStart(2, '0');
        const mes = (fechaConvertida.getMonth() + 1).toString().padStart(2, '0');
        const anio = fechaConvertida.getFullYear();
        const horas = fechaConvertida.getHours().toString().padStart(2, '0');
        const minutos = fechaConvertida.getMinutes().toString().padStart(2, '0');
      
        t.fechaEvidencia = `${dia}/${mes}/${anio} ${horas}:${minutos}`;
      
        console.log("Fecha seleccionada para el diálogo:", t.fechaEvidencia);
      }

      // Abrir el diálogo de evidencias
      t.dialogEvidenciasVisible = true;

      console.log("Evidencias obtenidas:", t.evidenciaData);
    })
    .catch(function(error) {
      console.log("Error al obtener evidencias:", error);
    });
},
    cerrarEvidencia() {
      this.dialogEvidenciasVisible = false; // Cierra el diálogo
      this.limpiarCamposEvidencia();
    },
    loadUserData() {
        const userString = localStorage.getItem('user');
        if (userString) {
          const user = JSON.parse(userString);
          const matricula = user.Usuario.Matricula;
          // console.log('Matrícula recuperada:', matricula);
          this.user = user;
          this.evidencia.Matricula_realizo = matricula;
          this.consultarEmpleado();
          } else {
          console.log('No se encontró el valor en localStorage.');
        }
    },
    autofillMatricula() {
      this.loadUserData();
    },
    consultarEmpleado(){
      const matricula = this.evidencia.Matricula_realizo;
      if (matricula) {
        this.matriculaEmpleado(matricula);
      }else {
        this.evidencia.Nombres = '';
      }
    },
    matriculaEmpleado(matricula) {
      console.log('Consultando empleado para matrícula:', matricula);
      var t = this;
      const srvrEquipos = new SrvrEquipos();
      t.loading = true;
      srvrEquipos.getEmpleado(t, matricula)
        .then((res) => {
          if (res) {
            t.evidencia.Nombres = `${res.Nombres || ''} ${res.Ap_pat || ''} ${res.Ap_mat || ''}`.trim();
            console.log('Nombre autocompletado:', t.evidencia.Nombres);
          } else {
            t.evidencia.Nombres = '';
            t.evidencia.Apellidos = '';
            t.$toast.add({ severity: 'warn', summary: 'Advertencia', detail: 'Empleado no encontrado', life: 3000 });
          }
          t.loading = false;
        })
        .catch(function (error) {
          console.error("Error:", error);
          t.loading = false;
          t.$toast.add({ severity: 'error', summary: 'Error', detail: 'Error consultando el empleado', life: 3000 });
        });
    },
    onFileSelect(event, index, accordion) {
      const file = event.files[0];
      console.log('Selected file:', file);
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          console.log('File loaded:', e.target.result);
          this[accordion][index].imageUrl = e.target.result;
        };
        reader.readAsDataURL(file);
        this[accordion][index].fileName = file.name;
        console.log('File name set:', file.name);
      }
    },
    onUpload(event) {
      console.log('Archivo cargado', event);
    },
    removeImage(index, accordion) {
      this[accordion][index].imageUrl = null;
      this[accordion][index].Observaciones = '';
      this[accordion][index].fileName = '';

      const fileUploadRef = this.$refs['fileUploadRef' + (
        accordion === 'fileUploadsAccordion1' ? '1' :
        accordion === 'fileUploadsAccordion2' ? '2' :
        accordion === 'fileUploadsAccordion3' ? '3' :
        accordion === 'fileUploadsAccordion4' ? '4' : '5') + index];
      if (fileUploadRef && fileUploadRef.clear) {
        fileUploadRef.clear();
      }
    },
    removeFileUpload(index, accordion) {
      this[accordion].splice(index, 1);
    },
    addFileUpload(accordion) {
      if (this[accordion].length < 4) {
        this[accordion].push({ imageUrl: null, Observaciones: '', fileName: '' });
      } else {
        this.$toast.add({ severity: 'warn', summary: 'Límite alcanzado', detail: 'Solo puedes agregar hasta 4 archivos.', life: 3000 });
      }
      event.target.blur();
    },
    resetAcordeonesYFileUploads() {
      // Reseteo de índices de acordeones
      this.activeAccordionIndex1 = 1;
      this.activeAccordionIndex2 = 2;
      this.activeAccordionIndex3 = 3;
      this.activeAccordionIndex4 = 4;
      this.activeAccordionIndex5 = 5;

      // Reseteo de FileUploads de cada acordeón
      this.fileUploadsAccordion1 = [{ imageUrl: null, Observaciones: '', fileName: '' }];
      this.fileUploadsAccordion2 = [{ imageUrl: null, Observaciones: '', fileName: '' }];
      this.fileUploadsAccordion3 = [{ imageUrl: null, Observaciones: '', fileName: '' }];
      this.fileUploadsAccordion4 = [{ imageUrl: null, Observaciones: '', fileName: '' }];
      this.fileUploadsAccordion5 = [{ imageUrl: null, Observaciones: '', fileName: '' }];
    }
  },
  computed: {
    ...mapGetters(["getUrlServicios", "getUsuarioLogueado"]),
  },
};
</script>

<style scoped>
.table-header {
  display: flex;
  justify-content: space-between;
  -webkit-box-pack: justify;
}
.title {
  font-weight: 700;
  letter-spacing: 0.3px;
  margin-right: 10px;
  text-transform: uppercase;
}
.data {
  letter-spacing: 0.3px;
  margin-right: 10px;
  letter-spacing: 0.5px;
}
.product-image {
  width: 100px;
}

.botones-container {
  display: flex;
  justify-content: left;
  align-items: left;
}
.close-button {
.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
  background: transparent;
  background: transparent;
  border: none;
  border: none;
  margin: 3px; /* Sin margen extra */
  padding: 0;
  opacity: 0;
  cursor: pointer; /* Indicar que es clicable */
  transition: opacity 0.2s, transform 0.2s;
  width: 40px; /* Ancho más grande */
  width: 50px;  /* Adjust the size as needed */
  height: 40px; /* Altura más pequeña para hacerlo cuadrado */
  height: 50px;
  border-radius: 4px; /* Bordes ligeramente redondeados */
  margin: 0.5rem;
  border-radius: 50%;
}
}
.close-button:hover {
  opacity: 1; /* Efecto hover para mayor visibilidad */
  transform: scale(1.1); /* Efecto de zoom */
}
.image-preview-container {
  display: flex;
  align-items: center;
  border: 2px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  margin-top: 10px;
}
.image-preview {
  margin-right: 10px;
}
.image-preview img {
  max-width: 155px;
  height: auto;
  display: block;
}

.image-info {
  position: relative;
  flex: 1;
}
.image-info label {
  display: block;
  margin-bottom: 5px;
}
textarea {
  width: 35%;
  resize: none;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
  box-sizing: border-box;
}
.remove-image-btn {
  position: absolute;
  top: 5px;
  right: 5px;
}
.fixed-fields {
  position: sticky;
  top: 0;
  background-color: #fff; /* Color de fondo para que no se mezcle con el contenido al hacer scroll */
  z-index: 10; /* Asegura que esté sobre el contenido desplazable */
  padding: 1em; /* Espacio interno para el diseño */
}


/* Estilos para el contenedor desplazable */
.scrollable-content {
max-height: 80vh;
overflow-y: auto;

}
.p-field {
  display: flex;
  justify-content: space-between; /* Espacio uniforme entre elementos */
  align-items: center;
  flex-wrap: wrap; /* Permitir ajuste si el espacio es insuficiente */
}

.field-item {
  flex: 0 0 auto; /* Evita que los elementos se expandan para ocupar todo el espacio disponible */
  text-align: left;
  margin-right: 0; /* Ajusta el espacio entre los elementos */
  font-size: 1.3rem; /* Reduce ligeramente el tamaño de fuente */
  line-height: 1; /* Reduce el espaciado vertical de cada línea */
  margin: 0; /* Elimina márgenes */
    padding: 0.2rem 0.5rem; /* Ajusta el padding para que sea más compacto */
    font-weight: normal; /* Cambia el peso de la fuente si es necesario */
}

h5 {
  margin: 0; /* Sin margen adicional */
}

.opacity-box {
    background-color: rgba(255, 255, 255, 0.5); /* Fondo blanco con 50% de opacidad */
    padding: 0.5rem 1rem; /* Espaciado interno */
    border-radius: 10px; /* Bordes redondeados */
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); /* Sombra para un efecto de elevación */
}
.p-field.p-flex {
  display: flex;
  flex-wrap: wrap; /* Permite que los elementos se ajusten en varias líneas si es necesario */
  gap: 1rem; /* Espacio entre cada elemento, ajusta según tus necesidades */
  align-items: center; /* Alinea verticalmente los elementos en el centro */
}
.custom-footer {
  height: 100px; /* Ajustar altura según el contenido */
  min-height: 120px; /* Altura mínima para que sea más compacto */
  display: flex; /* Usar flexbox para alinear el contenido */
  justify-content: flex-end; /* Alinear el contenido a la derecha */
  align-items: center; /* Centrar verticalmente el contenido */
  padding: 0 0.5rem; /* Reducir el padding horizontal */
}
 
.wrapper-list {
  flex: 1 1 auto;
 
  overflow-y: auto; /* Permite el scroll vertical aquí */
}
  .DataTable .p-datatable-tbody > tr {
      height: auto;
      padding: 0.5rem;
  }
 
  .observaciones-box {
      max-height: 60px; /* Limitar la altura para observaciones largas */
      overflow-y: auto; /* Habilitar scroll si el texto es muy largo */
      padding: 0.5rem;
      background-color: #f9f9f9;
      border: 1px solid #ddd;
      border-radius: 4px;
  }
 
  .observacion-text {
      font-size: 0.9rem;
      line-height: 1.4;
      white-space: pre-line; /* Mantener los saltos de línea */
  }
 
  .preview-image {
      cursor: pointer;
      border-radius: 4px;
      transition: transform 0.2s;
  }
 
  .preview-image:hover {
      transform: scale(1.1); /* Efecto de zoom */
  }
  .opacity-box {
    padding-bottom: 0;
    background-color: transparent; /* Elimina el color de fondo */
    box-shadow: none; /* Quita cualquier sombra */
    border: none; /* Quita el borde */
    padding: 0; /* Ajusta el padding */
    margin: 0; /* Ajusta el margen */
}
.opacity-box,
  .root {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden; /* Evita que el scroll esté en el contenedor, lo mantenemos solo en .wrapper-list */
}

.DataTable {

    width: 100%;  
}
.p-datatable-wrapper {
  flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

.header-section { /* Nombre de la clase para la sección de información */
  flex: 0 0 auto;
  padding: 0.5rem 1rem; /* Ajusta el padding si es necesario */
}
#footer-primary {
  height: 1px; /* Ajusta la altura a 150px, o el valor que prefieras */
  padding: 1rem; /* Ajusta el padding interno */
  background-color: #f9f9f9; /* Cambia el color de fondo, si lo necesitas */
  }
.custom-footer-large {
  height: 1px; /* Cambia la altura a 150px */
  padding: 1rem; /* Ajusta el padding para hacer el contenedor más compacto */
   background-color: #f0f0f0; /* Cambia el color de fondo */
  }
  .highlight-title {
    background-color: #f0f8ff; /* Fondo azul claro */
    padding: 10px;
    border-bottom: 4px solid #007acc; /* Borde azul */
    color: #003366; /* Texto en color azul oscuro */
    font-weight: bold;
    text-transform: uppercase;
}
.highlight-title1 {
    background-color: #f0f8ff; /* Fondo azul claro */
    padding: 10px;
    border-bottom: 4px solid #41f044; /* Borde azul */
    color: #0f833f; /* Texto en color azul oscuro */
    font-weight: bold;
    text-transform: uppercase;
}
.highlight-title2 {
    background-color: #f0f8ff; /* Fondo azul claro */
    padding: 10px;
    border-bottom: 4px solid rgb(235, 156, 80); /* Borde azul */
    color: #c4882e; /* Texto en color azul oscuro */
    font-weight: bold;
    text-transform: uppercase;
}
.highlight-title3 {
    background-color: #f0f8ff; /* Fondo azul claro */
    padding: 10px;
    border-bottom: 4px solid #4f5da6; /* Borde azul */
    color: #2d3f99; /* Texto en color azul oscuro */
    font-weight: bold;
    text-transform: uppercase;
}
.highlight-title4 {
    background-color: #f0f8ff; /* Fondo azul claro */
    padding: 10px;
    border-bottom: 4px solid rgb(203, 106, 162); /* Borde azul */
    color:rgb(203, 106, 162); /* Texto en color azul oscuro */
    font-weight: bold;
    text-transform: uppercase;
}

</style>